var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutoline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100%",
    viewBox: "0 0 1827 576",
    enableBackground: "new 0 0 1827 576",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1240.250000,117.000000  C1243.622803,115.934166 1247.091064,116.547310 1250.500000,116.542892  C1299.000000,116.479980 1347.500000,116.500000 1396.250000,116.500000  C1396.250000,118.320923 1396.250000,120.158936 1396.250000,122.250000  C1399.984131,122.250000 1403.492065,122.250000 1407.250000,122.250000  C1407.250000,120.679077 1407.250000,118.841064 1407.250000,116.750000  C1467.999023,116.750000 1528.499512,116.750000 1589.250000,116.750000  C1589.250000,118.320923 1589.250000,120.158936 1589.250000,122.250000  C1593.318848,122.250000 1597.159424,122.250000 1601.500000,122.250000  C1601.500000,118.681122 1601.500000,114.840561 1601.500000,110.750000  C1597.681152,110.750000 1593.840576,110.750000 1589.713623,110.750000  C1588.956787,111.541443 1589.778931,112.849373 1589.403320,114.250000  C1529.000977,114.250000 1468.500488,114.250000 1407.713623,114.250000  C1406.956787,113.458557 1407.778931,112.150627 1407.403320,110.750000  C1404.015869,110.750000 1400.507935,110.750000 1396.713623,110.750000  C1395.956787,111.541443 1396.778931,112.849373 1396.421021,114.183685  C1396.022095,114.272491 1395.511108,114.485710 1395.000000,114.485870  C1346.000000,114.501038 1297.000000,114.492233 1248.000000,114.530380  C1246.173218,114.531807 1244.254761,113.969620 1242.500000,115.000000  "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1238.500000,123.500000  C1238.500000,144.666672 1238.500000,165.833328 1238.500000,187.500000  C1164.500732,187.500000 1090.500366,187.500000 1016.500000,187.500000  "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1026.500000,391.500000  C1028.918579,391.045898 1030.745728,392.103729 1031.926270,394.044800  C1032.326782,394.703186 1031.648071,395.725281 1031.036011,396.527466  C1029.432373,398.629456 1027.684326,398.975403 1025.494629,397.508026  C1023.663269,396.280762 1021.553162,396.501892 1019.500000,396.501831  C943.166687,396.499695 866.833313,396.495972 790.500000,396.533508  C789.179260,396.534149 787.873718,396.258942 786.467651,396.932404  C783.745117,398.236420 780.881592,398.779022 777.969360,397.051697  C777.142517,396.561340 776.091614,397.062408 775.500000,398.000000  "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M489.000000,220.000000  C490.457672,220.523819 491.861420,221.033173 493.499878,221.038223  C531.500061,221.155411 569.499878,221.380692 607.500061,221.484497  C636.166504,221.562805 664.833435,221.547409 693.499939,221.477173  C705.333618,221.448181 717.166687,221.166656 729.000000,220.999985  "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1299.500000,307.500000  C1297.639282,308.668915 1295.562012,308.505493 1293.500000,308.505005  C1263.166626,308.497772 1232.833374,308.500000 1202.500000,308.500000  C1167.666626,308.500000 1132.833374,308.490173 1098.000000,308.509003  C1091.664062,308.512451 1085.313110,308.064819 1079.000000,309.000000  "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 15,
    d: " M272.250000,401.500000  C264.850281,399.916229 258.002563,396.775482 249.999023,396.818481  C188.500793,397.148621 126.999962,397.030701 65.500069,396.947418  C59.999535,396.939972 54.507866,398.032593 48.995377,397.025299  C47.260693,396.708344 45.313641,396.811707 44.048512,398.049591  C41.558899,400.485626 38.800148,399.687622 36.000000,399.250000  "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1774.000000,473.500000  C1775.071655,470.211914 1774.450684,466.829590 1774.464966,463.499847  C1774.539917,446.000183 1774.500000,428.500000 1774.500000,410.750000  C1759.003540,410.750000 1743.501831,410.750000 1727.750000,410.750000  C1727.750000,431.330658 1727.750000,452.165344 1727.750000,473.500000  C1739.828857,473.500000 1752.164551,473.469696 1764.499756,473.535919  C1766.157593,473.544800 1767.922485,472.941315 1769.500000,474.000000  "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1773.000000,119.500000  C1774.114990,116.722450 1773.135498,113.821693 1773.599487,110.750000  C1769.681152,110.750000 1765.840576,110.750000 1761.713623,110.750000  C1760.956787,111.541443 1761.778931,112.849373 1761.336304,114.500000  C1708.501099,114.500000 1655.500488,114.500000 1602.500000,114.500000  "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M335.500000,204.000000  C335.500000,264.500000 335.500000,325.000000 335.500000,385.500000  "
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1588.500000,483.000000  C1528.500000,483.000000 1468.500000,483.000000 1408.500000,483.000000  "
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1602.500000,116.500000  C1655.333374,116.500000 1708.166626,116.500000 1761.250000,116.500000  C1761.250000,118.320923 1761.250000,120.158936 1761.250000,122.854286  C1764.980103,121.457855 1768.785400,124.329803 1772.000000,121.000000  "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M327.000000,204.500000  C327.000000,207.500000 327.000000,210.500000 327.000000,213.500000  C327.000000,267.833344 326.999512,322.166656 327.001740,376.500000  C327.001831,378.778931 326.671143,381.139984 328.500000,383.000000  "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M763.000000,208.500000  C707.666687,208.500000 652.333313,208.500000 597.000000,208.500000  "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M242.000000,416.500000  C185.833328,416.500000 129.666672,416.500000 73.500000,416.500000  "
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M306.500000,36.999996  C309.666656,36.833328 312.833252,36.523212 316.000000,36.521393  C368.333344,36.491322 420.666748,36.464249 472.999786,36.588177  C476.163788,36.595665 479.956573,34.873005 482.500000,38.500000  "
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M194.000000,208.500000  C137.166672,208.500000 80.333336,208.500000 23.500000,208.500000  "
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1768.000000,482.250000  C1766.112061,483.396851 1764.019165,482.987213 1762.000000,482.987793  C1708.833374,483.003143 1655.666626,483.000000 1602.500000,483.000000  "
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M463.000000,204.500000  C463.000000,207.500000 463.000000,210.500000 463.000000,213.500000  C463.000000,267.833344 462.976654,322.166687 463.071350,376.499878  C463.075928,379.119965 462.009460,381.456818 462.000000,384.000000  "
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M401.000000,247.500000  C402.181213,244.896744 400.914185,242.140472 401.672821,238.750000  C419.154083,238.750000 436.827057,238.750000 454.500000,238.750000  C454.500000,287.500000 454.500000,336.500000 454.500000,385.500000  "
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M308.000000,201.500000  C308.000000,263.500000 308.000000,325.500000 308.000000,387.500000  "
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M300.500000,202.000000  C304.259277,202.685242 307.734375,200.244781 311.500000,201.093628  C311.500000,248.333328 311.515717,295.666687 311.447632,342.999939  C311.444611,345.087433 312.905762,348.908173 308.000000,347.500000  "
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M321.000000,204.000000  C321.000000,223.500000 321.301941,243.006027 320.912476,262.498260  C320.545624,280.859894 322.773010,299.169617 321.850647,317.492493  C321.422485,325.998474 320.994202,334.488037 321.035889,342.999817  C321.041534,344.153534 320.425842,345.462982 321.500000,346.500000  "
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M317.500000,204.000000  C317.500000,251.500000 317.495392,299.000000 317.562134,346.499908  C317.562836,347.000641 318.499969,347.500031 319.017242,348.017273  C320.968292,348.386993 321.269470,345.022980 323.665527,346.864288  C323.074432,338.505768 324.172119,330.977661 323.000000,323.500000  "
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M476.500000,554.000000  C480.000000,552.955688 483.500000,553.506287 487.250000,554.035217  C487.250000,557.666687 487.250000,561.333313 487.250000,565.250000  C483.333344,565.250000 479.666656,565.250000 476.019348,565.250000  C475.845215,562.988098 476.634705,561.233704 477.620697,558.916687  C463.166656,560.413025 448.834442,559.326294 434.499695,559.469177  C420.334442,559.610291 406.166656,559.500000 392.000000,559.500000  C378.000000,559.500000 364.000000,559.500000 350.000000,559.500000  C335.833344,559.500000 321.666656,559.500000 307.500000,559.500000  "
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1348.000000,228.500000  C1373.833374,228.500000 1399.666626,228.500000 1426.000000,228.500000  C1426.000000,195.333328 1426.000000,162.166672 1426.000000,128.750000  C1482.332397,128.750000 1539.166138,128.750000 1596.000000,128.750000  C1596.000000,161.831665 1596.000000,195.165833 1596.000000,228.500000  C1619.000000,228.500000 1641.500000,228.500000 1664.000000,228.500000  "
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1442.500000,144.500000  C1488.500000,144.500000 1534.500000,144.500000 1580.500000,144.500000  "
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1325.500000,394.000000  C1328.157471,390.783936 1325.657104,391.001923 1323.500000,391.000885  C1318.000000,390.998230 1312.446045,390.528015 1307.016968,391.148621  C1302.640869,391.648895 1298.298340,391.262390 1293.997925,391.310638  C1262.668457,391.662476 1231.333374,391.503906 1200.000000,391.478882  C1199.166870,391.478210 1198.180908,391.928802 1197.500000,391.000000  "
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M755.500000,226.500000  C753.922546,227.558701 752.156555,226.963821 750.499939,226.965698  C711.666687,227.009979 672.833313,227.008743 634.000000,226.983475  C630.884033,226.981445 627.793091,226.829773 625.629944,229.693008  C626.851318,231.767303 629.085144,230.971649 631.000061,230.974014  C661.000000,231.011078 691.000000,230.999817 721.000000,231.000595  C722.260498,231.000626 723.583191,230.792114 724.500000,232.000000  "
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    d: " M753.000000,386.000000  C747.166687,386.000000 741.331604,385.916870 735.500793,386.037323  C732.841309,386.092224 730.223694,386.011841 728.039795,384.444550  C726.799927,383.554718 725.743652,382.966797 724.516296,384.019012  C721.682068,386.448822 718.301208,385.995697 715.000000,385.996399  C684.833313,386.002563 654.666687,386.000000 624.500000,386.000000  "
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 17,
    d: " M464.500000,393.000000  C471.011536,391.366150 476.748383,393.472961 481.947723,397.075439  C484.421295,398.789276 486.658264,398.793060 489.507538,398.647675  C495.991425,398.316681 502.424194,395.841095 509.015228,397.952423  C510.073334,398.291351 511.333344,398.000000 512.500000,398.000000  C547.333313,398.000000 582.166687,398.004852 617.000000,397.988464  C619.192322,397.987427 621.785706,398.706055 622.969116,395.986542  C624.498291,392.472229 625.259033,388.756378 623.933167,385.023743  C623.468140,383.714478 622.045654,383.342804 620.497009,383.461212  C616.908386,383.735535 613.215088,382.835022 609.924377,385.403107  C608.911316,386.193695 607.000122,385.977234 605.500000,385.978729  C576.833313,386.007568 548.166687,386.000000 519.500000,386.000000  C512.413269,382.523834 505.494812,386.115845 498.500000,386.500000  "
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1052.500000,375.000000  C1045.333374,374.110748 1038.078247,374.056519 1031.040894,375.242523  C1027.964355,375.760956 1025.338501,374.845459 1022.499207,374.861481  C985.500366,375.070282 948.500000,375.000000 911.500000,375.000000  C870.166687,375.000000 828.833313,375.000000 787.500000,375.000000  C782.000000,375.000000 776.500000,374.999115 771.000000,375.000641  C769.739502,375.001007 768.416809,374.792114 767.500000,376.000000  "
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M782.500000,386.000000  C784.112488,387.547821 786.133850,386.979034 788.000000,386.980377  C824.666687,387.006744 861.333313,387.000000 898.000000,387.000000  C939.666687,387.000000 981.333313,386.993744 1023.000000,387.009674  C1027.187500,387.011261 1031.521484,385.315033 1035.500000,388.000000  "
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1052.500000,339.000000  C1045.333374,338.110748 1038.078247,338.056519 1031.040894,339.242493  C1027.964355,339.760986 1025.338501,338.845428 1022.499207,338.861450  C985.500366,339.070251 948.500000,339.000000 911.500000,339.000000  C870.500000,339.000000 829.499939,338.973358 788.500000,339.022186  C780.166443,339.032104 771.819519,338.642700 763.500000,339.500000  "
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1052.500000,269.500000  C1052.520020,268.117371 1052.854248,266.852570 1050.497681,266.931061  C1043.988159,267.147919 1037.331421,266.389648 1031.052979,268.185242  C1027.915405,269.082520 1025.338501,267.845428 1022.499207,267.861450  C985.500366,268.070251 948.500000,268.000000 911.500000,268.000000  C870.166687,268.000000 828.831848,267.831787 787.501770,268.197845  C781.890137,268.247559 776.042969,266.563660 770.500000,269.000000  "
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1052.500000,359.000000  C1045.333374,358.110748 1038.078247,358.056519 1031.040894,359.242523  C1027.964355,359.760956 1025.338501,358.845459 1022.499207,358.861450  C985.500366,359.070251 948.500000,359.000000 911.500000,359.000000  C870.666687,359.000000 829.833130,358.934448 789.000183,359.053589  C780.503540,359.078369 771.983154,358.472717 763.500000,359.500000  "
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1052.500000,220.000000  C1045.333374,219.110733 1038.078247,219.056519 1031.040894,220.242493  C1027.964355,220.760971 1025.338501,219.845383 1022.499207,219.861404  C985.500366,220.070206 948.500000,220.000000 911.500000,220.000000  C870.166687,220.000000 828.833313,219.991058 787.500000,220.027069  C785.479614,220.028824 783.282837,219.363815 781.500000,221.000000  "
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1563.500000,170.000000  C1561.922485,168.941299 1560.156494,169.534836 1558.500000,169.533890  C1489.333374,169.494370 1420.166626,169.500000 1350.500000,169.500000  C1350.500000,183.662750 1350.500000,197.831375 1350.500000,212.000000  "
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M903.500000,265.000000  C902.646179,266.043793 901.487122,265.468292 900.500000,265.469238  C862.166687,265.505493 823.833313,265.505493 785.500000,265.469238  C784.512878,265.468292 783.353821,266.043793 782.500000,265.000000  "
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1027.500000,372.000000  C1026.646240,373.043793 1025.487183,372.468323 1024.500000,372.469238  C986.166687,372.505524 947.833313,372.505493 909.500000,372.469208  C908.512878,372.468292 907.353821,373.043793 906.500000,372.000000  "
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M903.500000,336.000000  C902.646179,337.043793 901.487122,336.468292 900.500000,336.469238  C862.166687,336.505493 823.833313,336.505524 785.500000,336.469238  C784.512878,336.468292 783.353821,337.043793 782.500000,336.000000  "
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1027.500000,336.000000  C1026.646240,337.043793 1025.487183,336.468323 1024.500000,336.469238  C986.166687,336.505524 947.833313,336.505493 909.500000,336.469208  C908.512878,336.468292 907.353821,337.043793 906.500000,336.000000  "
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M903.500000,356.000000  C902.646179,357.043793 901.487122,356.468292 900.500000,356.469238  C862.166687,356.505493 823.833313,356.505493 785.500000,356.469238  C784.512878,356.468292 783.353821,357.043793 782.500000,356.000000  "
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1027.500000,356.000000  C1026.646240,357.043793 1025.487183,356.468323 1024.500000,356.469238  C986.166687,356.505524 947.833313,356.505493 909.500000,356.469208  C908.512878,356.468292 907.353821,357.043793 906.500000,356.000000  "
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1194.500000,219.000000  C1192.922485,217.941299 1191.156738,218.537308 1189.500000,218.534592  C1160.333374,218.486771 1131.166626,218.481918 1102.000000,218.525803  C1098.808105,218.530609 1095.776123,218.174057 1092.888062,216.446167  C1089.400635,221.935883 1083.814819,219.474380 1078.995239,219.951614  C1077.526123,220.097076 1076.000000,219.666672 1074.500000,219.500000  "
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M903.500000,372.000000  C902.646179,373.043793 901.487122,372.468292 900.500000,372.469238  C862.166687,372.505493 823.833313,372.505493 785.500000,372.469238  C784.512878,372.468292 783.353821,373.043793 782.500000,372.000000  "
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1027.500000,265.000000  C1026.646240,266.043793 1025.487183,265.468323 1024.500000,265.469238  C986.166687,265.505524 947.833313,265.505493 909.500000,265.469208  C908.512878,265.468292 907.353821,266.043793 906.500000,265.000000  "
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M903.500000,217.000000  C902.646179,218.043808 901.487122,217.468307 900.500000,217.469238  C862.166687,217.505508 823.833313,217.505508 785.500000,217.469238  C784.512878,217.468307 783.353821,218.043808 782.500000,217.000000  "
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1027.500000,217.000000  C1026.646240,218.043808 1025.487183,217.468292 1024.500000,217.469223  C986.166687,217.505493 947.833313,217.505508 909.500000,217.469238  C908.512878,217.468307 907.353821,218.043808 906.500000,217.000000  "
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1294.500000,401.000000  C1292.922485,399.941315 1291.157104,400.540375 1289.499878,400.535248  C1271.333496,400.479034 1253.159790,400.178558 1235.001343,400.563263  C1189.500977,401.527130 1143.999146,400.654480 1098.500244,401.031372  C1091.801025,401.086853 1085.106323,401.541138 1078.500000,400.000000  "
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1025.500000,391.000000  C1024.058716,389.539612 1022.213318,390.013580 1020.500000,390.012787  C983.833313,389.995941 947.166687,390.000000 910.500000,390.000000  C876.333313,390.000000 842.166687,389.992767 808.000000,390.019653  C806.133850,390.021118 804.112488,389.452179 802.500000,391.000000  "
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M728.000000,295.000000  C728.000000,291.333344 728.027832,287.666412 727.993835,284.000061  C727.935120,277.676758 727.672302,277.486420 721.500000,277.490540  C690.500000,277.511230 659.500000,277.500000 628.500000,277.500000  C592.333313,277.500000 556.166687,277.500000 520.000000,277.500000  C512.166687,277.500000 504.333344,277.500000 496.500000,277.500000  C496.500000,276.166656 496.500000,274.833344 496.500000,273.500000  "
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1025.500000,392.000000  C1024.072632,393.297638 1022.365295,393.522003 1020.500000,393.520630  C983.000000,393.493042 945.500000,393.501953 908.000000,393.479248  C907.499939,393.478943 907.000000,393.166656 906.500000,393.000000  "
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M904.000000,214.000000  C898.359375,212.947784 892.670166,213.508896 887.000000,213.506500  C855.000000,213.493011 823.000000,213.504044 791.000000,213.488541  C789.325562,213.487732 787.648804,213.686249 785.988892,213.027969  C783.710205,212.124283 781.976440,211.731873 779.829651,214.360916  C777.055420,217.758453 766.161560,215.094666 764.564270,210.975067  C763.561035,208.387466 761.749634,206.005325 762.020874,202.750000  C765.666687,202.750000 769.333313,202.750000 773.500000,202.750000  C773.500000,206.993439 773.500000,210.996719 773.500000,215.000000  "
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M774.500000,207.500000  C813.166687,207.500000 851.833313,207.500000 890.500000,207.500000  "
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M483.000000,202.000000  C483.000000,263.833344 483.000000,325.666656 483.000000,387.500000  "
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M752.500000,332.500000  C748.666687,332.500000 744.813965,332.247314 741.002991,332.539093  C703.197205,335.433380 665.324219,333.123230 627.506409,334.220245  C619.962158,334.439117 612.515564,333.525635 604.995605,333.915131  C597.515686,334.302551 590.000000,334.000000 582.500000,334.000000  C575.166687,334.000000 567.833313,334.000000 560.500000,334.000000  C553.000000,334.000000 545.500000,334.000000 538.000000,334.000000  C530.666687,334.000000 523.330811,333.887665 516.001160,334.052124  C512.808838,334.123718 509.710175,333.702759 506.394531,335.278015  C503.132751,336.827728 499.265625,333.744812 495.500000,334.500000  "
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M479.500000,201.500000  C479.500000,248.666672 479.484192,295.833374 479.552368,342.999939  C479.555389,345.087433 478.094238,348.908173 483.000000,347.500000  "
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M473.500000,204.000000  C473.500000,250.166672 473.510071,296.333344 473.465454,342.499969  C473.463531,344.477020 474.567230,347.039612 471.500000,348.000000  "
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M620.500000,307.500000  C618.627258,305.377014 616.277466,304.940582 613.499878,304.947052  C578.833374,305.027954 544.166687,305.000000 509.500000,305.000000  "
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M265.500000,373.000000  C234.666672,373.000000 203.833328,373.000000 173.000000,373.000000  C135.500000,373.000000 98.000000,373.006195 60.500000,372.995239  C52.138763,372.992767 43.719383,373.899200 35.500000,371.500000  "
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M267.500000,266.000000  C265.602356,266.947418 263.587494,267.028595 261.499969,267.024780  C239.500031,266.984680 217.500000,267.000000 195.500000,267.000000  C150.500000,267.000000 105.500000,267.005280 60.500000,266.995270  C52.138763,266.993408 43.719383,267.899200 35.500000,265.500000  "
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M52.500000,301.000000  C48.926590,299.640839 45.085304,301.228302 41.517994,300.189972  C41.323959,297.569275 43.082577,298.009277 44.500015,298.005585  C49.833309,297.991669 55.166668,298.000000 60.500000,298.000000  C93.000000,298.000000 125.500000,298.000000 158.000000,298.000000  C194.500000,298.000000 231.000000,298.000000 267.500000,298.000000  "
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M302.500000,226.500000  C295.500427,226.315598 288.499573,226.470963 281.492126,226.219101  C277.535797,226.076920 273.500031,225.989822 269.500000,225.991653  C236.833328,226.006485 204.166672,226.000000 171.500000,226.000000  C134.333328,226.000000 97.166656,225.993332 60.000015,226.019608  C58.133907,226.020920 56.112514,225.452164 54.500000,227.000000  "
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M42.500000,388.000000  C118.001472,388.000000 193.502945,388.000000 269.780060,388.000000  C267.535156,391.473816 264.217957,390.937500 262.500000,393.000000  "
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M274.000000,354.000000  C276.656769,351.173889 276.623322,347.785156 275.437653,344.522675  C273.689636,339.712860 270.908295,335.267242 270.875000,330.000000  C238.000000,330.000000 205.500000,330.000000 173.000000,330.000000  C135.500000,330.000000 98.000000,330.006195 60.500000,329.995239  C52.138763,329.992767 43.719383,330.899200 35.500000,328.500000  "
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M54.500000,281.500000  C124.833336,281.500000 195.166672,281.500000 265.502625,281.499329  C265.459442,288.990784 267.143127,295.683807 270.483032,302.744537  C273.172058,308.429260 275.889160,315.052246 276.098541,321.997040  C276.191803,325.089752 274.340729,326.393219 272.500000,328.000000  "
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M265.500000,341.500000  C194.834854,340.843567 124.157280,342.822784 53.501011,340.469604  C53.468548,340.468506 53.451496,340.004761 53.376450,339.238495  C54.992672,337.834412 57.136200,338.536774 59.000023,338.535614  C127.166656,338.493256 195.333328,338.505707 263.499969,338.466095  C265.156433,338.465149 266.922546,339.058685 268.500000,338.000000  "
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M54.500000,277.500000  C125.666664,277.500000 196.833328,277.500000 268.000000,277.500000  "
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M267.500000,354.000000  C266.132660,355.829926 264.173950,354.956757 262.499908,354.961121  C240.166718,355.019257 217.833328,355.000000 195.500000,355.000000  C150.500000,355.000000 105.499489,354.890411 60.500465,355.099945  C52.300247,355.138092 44.153690,354.923920 36.000000,354.250000  "
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M267.500000,311.000000  C265.922546,312.058685 264.156433,311.465179 262.499969,311.466125  C193.166672,311.505615 123.833336,311.500000 54.500000,311.500000  "
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1211.500000,405.500000  C1206.000000,405.166687 1200.500854,404.563599 1194.999878,404.545166  C1166.166748,404.448547 1137.333374,404.517578 1108.500000,404.468109  C1106.083618,404.463989 1103.755005,404.618011 1101.500000,405.500000  "
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1035.500000,306.000000  C1032.017456,304.149414 1028.263794,304.467072 1024.500000,304.472260  C990.166687,304.519470 955.833252,304.537598 921.500122,304.454224  C917.014709,304.443329 912.644226,303.216705 908.515747,301.462891  C904.954407,299.949982 903.548828,291.231781 906.533508,289.045776  C909.548035,286.837982 912.833313,285.000000 916.000000,283.000000  "
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M164.500000,308.500000  C127.833336,308.500000 91.166664,308.500000 54.500000,308.500000  "
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M619.000000,308.500000  C582.500000,308.500000 546.000000,308.500000 509.500000,308.500000  "
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M275.500000,219.000000  C274.646179,217.956192 273.487183,218.531891 272.499969,218.530823  C238.166672,218.493851 203.833328,218.493851 169.500031,218.530823  C168.512833,218.531891 167.353806,217.956192 166.500000,219.000000  "
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M164.500000,219.000000  C163.646194,217.956192 162.487167,218.531891 161.499969,218.530838  C127.166672,218.493866 92.833328,218.493866 58.500034,218.530823  C57.512836,218.531891 56.353809,217.956192 55.500000,219.000000  "
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M906.500000,308.000000  C907.353821,306.956207 908.512878,307.531708 909.500000,307.530792  C947.833313,307.494507 986.166687,307.494476 1024.500000,307.530762  C1025.487183,307.531677 1026.646240,306.956207 1027.500000,308.000000  "
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M163.500000,301.000000  C162.646194,299.956207 161.487167,300.531891 160.499969,300.530823  C126.500008,300.493805 92.499992,300.493805 58.500034,300.530823  C57.512833,300.531891 56.353809,299.956207 55.500000,301.000000  "
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M752.500000,393.500000  C743.322815,393.544037 733.953979,392.415588 725.052063,394.702698  C717.198914,396.720367 709.259460,397.979370 701.532593,396.788635  C685.009155,394.242340 668.496643,395.890533 651.997742,395.659210  C642.676819,395.528503 633.333313,395.114349 624.000000,395.500000  "
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M163.500000,370.000000  C162.646194,371.043793 161.487167,370.468109 160.499969,370.469177  C126.500008,370.506195 92.499992,370.506195 58.500034,370.469177  C57.512833,370.468109 56.353809,371.043793 55.500000,370.000000  "
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1014.500000,207.500000  C975.500000,207.500000 936.500000,207.500000 897.500000,207.500000  "
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M163.500000,352.000000  C162.646194,353.043793 161.487167,352.468109 160.499969,352.469177  C126.500008,352.506195 92.499992,352.506195 58.500034,352.469177  C57.512833,352.468109 56.353809,353.043793 55.500000,352.000000  "
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M617.500000,311.500000  C581.500000,311.500000 545.500000,311.500000 509.500000,311.500000  "
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M163.500000,327.000000  C162.646194,328.043793 161.487167,327.468109 160.499969,327.469177  C126.500008,327.506195 92.499992,327.506195 58.500034,327.469177  C57.512833,327.468109 56.353809,328.043793 55.500000,327.000000  "
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M163.500000,264.000000  C162.646194,265.043793 161.487167,264.468109 160.499969,264.469177  C126.500008,264.506195 92.499992,264.506195 58.500034,264.469177  C57.512833,264.468109 56.353809,265.043793 55.500000,264.000000  "
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1196.500000,219.000000  C1198.077515,217.941299 1199.843262,218.537292 1201.500000,218.534576  C1230.666626,218.486755 1259.833374,218.498398 1289.000000,218.502197  C1292.310547,218.502625 1295.598511,218.426270 1298.519043,216.483643  C1299.511719,217.488251 1300.505859,218.494186 1301.499878,219.500137  "
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M271.000000,308.000000  C269.422546,309.058685 267.656616,308.463257 265.999939,308.465546  C232.500015,308.511536 199.000000,308.500000 165.500000,308.500000  "
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M270.500000,222.000000  C268.922546,220.941299 267.156647,221.536942 265.499939,221.534500  C233.833344,221.487793 202.166672,221.500000 170.500000,221.500000  C135.000000,221.500000 99.499985,221.490112 64.000046,221.534531  C62.511417,221.536392 60.894566,220.884430 59.500000,222.000000  "
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    d: " M325.000000,410.000000  C321.212738,411.439697 321.332916,415.402985 321.216522,418.009674  C320.711548,429.320465 321.077087,440.667511 320.953094,451.999481  C320.915833,455.406799 322.330170,456.497101 325.501190,456.007721  C334.831177,454.567780 344.476532,454.546295 353.414856,456.408691  C362.783417,458.360779 371.799377,457.549469 381.000061,457.515442  C396.333191,457.458740 411.666962,457.559723 426.999878,457.478516  C436.833832,457.426422 446.666687,457.060669 456.500000,457.062500  C459.581696,457.063080 462.074860,455.189484 465.544464,455.694305  C469.525452,456.273499 470.311615,457.680634 470.013763,461.001221  C469.924805,461.993256 470.000000,463.000000 470.000000,464.000000  "
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1331.500000,248.000031  C1331.116943,248.459976 1330.733887,248.919937 1329.625977,250.250000  C1450.832153,250.250000 1571.165771,250.250000 1691.705933,250.250000  C1691.410156,249.307281 1691.205078,248.653641 1691.000000,247.999985  "
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M270.500000,223.000000  C269.646179,224.043808 268.487183,223.468002 267.499969,223.469131  C234.833328,223.506439 202.166672,223.506454 169.500031,223.469147  C168.512817,223.468018 167.353806,224.043808 166.500000,223.000000  "
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M163.500000,223.000000  C162.646194,224.043808 161.487183,223.468018 160.499969,223.469147  C127.833344,223.506439 95.166656,223.506454 62.500034,223.469147  C61.512821,223.468018 60.353809,224.043808 59.500000,223.000000  "
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M727.500000,308.500000  C694.500000,308.500000 661.500000,308.511688 628.500061,308.465515  C626.843384,308.463196 625.077454,309.058685 623.500000,308.000000  "
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M624.000000,305.000000  C657.166687,305.000000 690.341797,305.416351 723.494690,304.739929  C733.124023,304.543457 742.806885,303.488464 752.500000,303.500000  "
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M614.500000,297.000000  C613.219055,298.319183 611.565857,297.994965 610.000000,297.995270  C578.666687,298.001587 547.333313,298.001617 516.000000,297.995300  C514.434143,297.994965 512.780945,298.319183 511.500000,297.000000  "
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M614.500000,331.000000  C613.219055,329.680817 611.565857,330.005035 610.000000,330.004730  C578.666687,329.998413 547.333313,329.998383 516.000000,330.004700  C514.434143,330.005035 512.780945,329.680817 511.500000,331.000000  "
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1032.000000,215.750000  C1028.859619,211.082291 1024.039551,212.933334 1020.005798,213.123215  C1006.666931,213.751053 993.333313,213.415771 979.999878,213.471802  C956.166992,213.571960 932.333313,213.497498 908.500000,213.512680  C907.816772,213.513107 907.002808,213.177994 906.500000,214.000000  "
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M615.500000,342.000031  C613.833313,341.833344 612.166809,341.522858 610.500000,341.521332  C579.166687,341.492340 547.833313,341.494598 516.500000,341.521088  C515.333191,341.522064 514.166687,341.833344 513.000000,342.000000  "
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1298.500000,225.000000  C1297.219116,223.680801 1295.565796,224.005020 1294.000000,224.004700  C1263.000000,223.998367 1232.000000,223.998367 1201.000000,224.004700  C1199.434204,224.005020 1197.780884,223.680801 1196.500000,225.000000  "
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M268.500000,300.500000  C236.166672,300.500000 203.833313,300.488068 171.500046,300.534515  C169.843338,300.536896 168.077469,299.941315 166.500000,301.000000  "
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1194.500000,221.000000  C1193.646240,222.043808 1192.487183,221.467972 1191.500000,221.469131  C1159.500000,221.506577 1127.500000,221.506577 1095.500000,221.469131  C1094.512817,221.467972 1093.353760,222.043808 1092.500000,221.000000  "
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M276.000000,385.500000  C276.000000,383.666656 276.105896,381.826080 275.980530,380.001343  C275.568970,374.009857 271.839783,370.500000 266.000000,370.500000  C234.500000,370.500000 202.999985,370.512238 171.500046,370.465454  C169.843323,370.463013 168.077469,371.058685 166.500000,370.000000  "
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1298.500000,221.000000  C1297.646240,222.043808 1296.487183,221.467972 1295.500000,221.469131  C1263.500000,221.506577 1231.500000,221.506577 1199.500000,221.469131  C1198.512817,221.467972 1197.353760,222.043808 1196.500000,221.000000  "
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1298.500000,273.000000  C1297.219116,271.680817 1295.565796,272.005035 1294.000000,272.004730  C1263.000000,271.998383 1232.000000,271.998383 1201.000000,272.004700  C1199.434204,272.005035 1197.780884,271.680817 1196.500000,273.000000  "
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1298.500000,313.000000  C1297.219116,311.680817 1295.565796,312.005035 1294.000000,312.004730  C1263.000000,311.998383 1232.000000,311.998383 1201.000000,312.004700  C1199.434204,312.005035 1197.780884,311.680817 1196.500000,313.000000  "
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1194.500000,340.000000  C1193.219116,341.319183 1191.565796,340.994965 1190.000000,340.995270  C1159.000000,341.001617 1128.000000,341.001617 1097.000000,340.995270  C1095.434204,340.994934 1093.780884,341.319183 1092.500000,340.000000  "
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1194.500000,313.000000  C1193.219116,311.680817 1191.565796,312.005035 1190.000000,312.004730  C1159.000000,311.998383 1128.000000,311.998383 1097.000000,312.004730  C1095.434204,312.005066 1093.780884,311.680817 1092.500000,313.000000  "
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1194.500000,273.000000  C1193.219116,271.680817 1191.565796,272.005035 1190.000000,272.004730  C1159.000000,271.998383 1128.000000,271.998383 1097.000000,272.004730  C1095.434204,272.005066 1093.780884,271.680817 1092.500000,273.000000  "
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1194.500000,380.000000  C1193.219116,378.680817 1191.565796,379.005035 1190.000000,379.004730  C1159.000000,378.998383 1128.000000,378.998383 1097.000000,379.004730  C1095.434204,379.005066 1093.780884,378.680817 1092.500000,380.000000  "
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1194.500000,364.000000  C1193.219116,362.680817 1191.565796,363.005035 1190.000000,363.004730  C1159.000000,362.998383 1128.000000,362.998383 1097.000000,363.004730  C1095.434204,363.005066 1093.780884,362.680817 1092.500000,364.000000  "
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M266.000000,313.500000  C264.994690,318.340485 266.752838,322.669220 268.327698,327.500000  C266.866638,327.500000 265.183319,327.500000 263.500000,327.500000  C232.833328,327.500000 202.166656,327.512573 171.500046,327.465424  C169.843323,327.462891 168.077469,328.058685 166.500000,327.000000  "
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M268.000000,352.500000  C235.833328,352.500000 203.666656,352.511993 171.500046,352.465515  C169.843338,352.463104 168.077469,353.058685 166.500000,352.000000  "
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M613.500000,301.000000  C612.646179,299.956207 611.487183,300.532074 610.499939,300.530884  C578.833313,300.493347 547.166687,300.493347 515.500061,300.530884  C514.512817,300.532043 513.353821,299.956207 512.500000,301.000000  "
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M720.500000,219.000000  C719.646179,217.956192 718.487183,218.532043 717.499939,218.530869  C685.833313,218.493347 654.166687,218.493347 622.500061,218.530884  C621.512817,218.532043 620.353821,217.956192 619.500000,219.000000  "
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M613.500000,327.000000  C612.646179,328.043793 611.487183,327.467926 610.499939,327.469116  C578.833313,327.506653 547.166687,327.506653 515.500061,327.469116  C514.512817,327.467957 513.353821,328.043793 512.500000,327.000000  "
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1704.500000,200.000000  C1704.500000,190.000000 1704.500000,180.000000 1704.500000,169.500000  C1701.518555,169.500000 1698.509277,169.500000 1695.500000,169.500000  C1676.500000,169.500000 1657.500000,169.479935 1638.500122,169.535187  C1636.843018,169.539993 1635.077515,168.941299 1633.500000,170.000000  "
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M627.000000,311.500000  C660.500000,311.500000 694.000000,311.500000 727.500000,311.500000  "
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M275.500000,274.500000  C270.528961,272.962036 267.595490,269.478546 267.489349,264.500000  C265.844055,264.500000 264.172028,264.500000 262.500000,264.500000  C232.166672,264.500000 201.833313,264.512726 171.500061,264.465454  C169.843307,264.462860 168.077469,265.058685 166.500000,264.000000  "
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M617.500000,279.000000  C617.333313,281.333344 617.114258,283.664337 617.011169,286.000488  C616.813354,290.481415 617.549744,294.377014 621.414307,297.602661  C625.364441,300.899750 624.922913,304.064697 621.000000,307.499969  C615.755676,312.092316 616.106262,319.837006 620.321533,325.141815  C623.927795,329.680206 627.975769,330.086426 633.000305,330.063782  C661.999695,329.933075 691.000000,329.991516 720.000000,330.019806  C721.866150,330.021606 723.887512,329.452179 725.500000,331.000000  "
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M903.500000,393.000000  C902.646179,394.043793 901.487183,393.467926 900.499939,393.469116  C869.166687,393.506714 837.833313,393.506744 806.500061,393.469116  C805.512817,393.467926 804.353821,394.043793 803.500000,393.000000  "
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1297.500000,269.000000  C1296.646240,270.043793 1295.487183,269.467926 1294.500000,269.469116  C1263.166626,269.506714 1231.833374,269.506714 1200.500000,269.469116  C1199.512817,269.467926 1198.353760,270.043793 1197.500000,269.000000  "
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1193.500000,376.000000  C1192.646240,377.043793 1191.487183,376.467926 1190.500000,376.469116  C1159.166626,376.506714 1127.833374,376.506714 1096.500000,376.469116  C1095.512817,376.467926 1094.353760,377.043793 1093.500000,376.000000  "
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1193.500000,269.000000  C1192.646240,270.043793 1191.487183,269.467926 1190.500000,269.469116  C1159.166626,269.506714 1127.833374,269.506714 1096.500000,269.469116  C1095.512817,269.467926 1094.353760,270.043793 1093.500000,269.000000  "
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1193.500000,360.000000  C1192.646240,361.043793 1191.487183,360.467926 1190.500000,360.469116  C1159.166626,360.506714 1127.833374,360.506714 1096.500000,360.469116  C1095.512817,360.467926 1094.353760,361.043793 1093.500000,360.000000  "
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1193.500000,344.000000  C1192.646240,342.956207 1191.487183,343.532074 1190.500000,343.530884  C1159.166626,343.493286 1127.833374,343.493286 1096.500000,343.530884  C1095.512817,343.532074 1094.353760,342.956207 1093.500000,344.000000  "
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M720.500000,223.000000  C719.646179,224.043808 718.487183,223.467941 717.499939,223.469116  C686.166687,223.506729 654.833313,223.506729 623.500061,223.469116  C622.512817,223.467941 621.353821,224.043808 620.500000,223.000000  "
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1596.500000,251.500000  C1596.500000,308.500000 1596.500000,365.500000 1596.500000,422.500000  C1619.000000,422.500000 1641.500000,422.500000 1664.000000,422.500000  "
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1581.500000,251.500000  C1581.500000,311.500000 1581.500000,371.500000 1581.500000,431.500000  "
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M724.500000,301.000000  C723.819092,300.071198 722.833130,300.521820 722.000000,300.521149  C691.000000,300.496063 660.000000,300.493774 629.000000,300.521149  C627.666565,300.522339 626.333313,300.833344 625.000000,301.000000  "
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1425.500000,251.500000  C1425.500000,308.500000 1425.500000,365.500000 1425.500000,422.500000  C1399.666626,422.500000 1373.833374,422.500000 1348.000000,422.500000  "
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1441.500000,251.500000  C1441.500000,308.500000 1441.500000,365.500000 1441.500000,422.500000  C1448.500000,422.500000 1455.500000,422.500000 1462.500000,422.500000  "
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1295.500000,395.000000  C1294.219116,393.680817 1292.565796,394.005035 1291.000000,394.004700  C1261.000000,393.998322 1231.000000,393.998322 1201.000000,394.004700  C1199.434204,394.005035 1197.780884,393.680817 1196.500000,395.000000  "
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M626.500000,360.000000  C659.166687,360.000000 691.855591,360.664337 724.485596,359.570892  C733.568176,359.266510 742.805298,358.281128 752.000000,358.000000  "
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1294.500000,397.000000  C1293.646240,398.043793 1292.487183,397.467865 1291.500000,397.469086  C1261.166626,397.506927 1230.833374,397.506958 1200.500000,397.469116  C1199.512817,397.467865 1198.353760,398.043793 1197.500000,397.000000  "
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M724.500000,327.000000  C722.922546,328.058685 721.156677,327.462646 719.499939,327.465393  C690.500000,327.513275 661.500000,327.486725 632.500061,327.534637  C630.843323,327.537354 629.077454,326.941315 627.500000,328.000000  "
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M721.500000,392.000000  C719.887512,390.452179 717.866150,391.021454 716.000000,391.019745  C685.666687,390.991882 655.333313,391.000000 625.000000,391.000000  "
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M499.500000,357.500000  C517.174072,361.741699 535.150818,359.652008 553.000977,359.937439  C570.829773,360.222534 588.713379,360.729523 606.473938,359.592896  C612.456909,359.210022 620.000244,361.102753 625.077332,355.065033  C625.491577,354.572449 627.000000,355.000000 628.000000,355.000000  C657.666687,355.000000 687.333313,354.998291 717.000000,355.004700  C718.565857,355.005066 720.219055,354.680817 721.500000,356.000000  "
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M721.500000,268.000000  C720.058716,266.539612 718.213318,267.013916 716.500000,267.012878  C687.166687,266.994965 657.833313,267.000000 628.500000,267.000000  C627.500000,267.000000 626.494873,266.936554 625.501343,267.016449  C624.326294,267.110962 623.781677,267.907318 624.034790,268.991882  C624.252808,269.926147 625.055237,270.175934 626.002502,270.014557  C626.488403,269.931763 627.000000,270.000000 627.500000,270.000000  C657.333313,270.000000 687.166687,270.001678 717.000000,269.995270  C718.565857,269.994934 720.219055,270.319183 721.500000,269.000000  "
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M721.500000,380.000000  C719.887512,378.452179 717.866150,379.021454 716.000000,379.019745  C685.666687,378.991882 655.333313,379.000000 625.000000,379.000000  "
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M721.500000,274.000000  C719.887512,272.452179 717.866150,273.021454 716.000000,273.019745  C685.666687,272.991882 655.333313,273.000000 625.000000,273.000000  "
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M721.500000,375.000000  C720.058716,376.460388 718.213318,375.986084 716.500000,375.987122  C687.000000,376.005035 657.493713,376.315674 628.005432,375.727600  C622.263611,375.613098 616.369324,374.580414 610.500000,374.500000  "
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M724.000000,342.000000  C722.228210,341.156647 720.338684,341.515076 718.500000,341.513885  C688.333313,341.494293 658.166687,341.500000 628.000000,341.500000  "
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M721.500000,374.000000  C720.219055,372.680817 718.565857,373.005066 717.000000,373.004730  C688.166687,372.998260 659.333313,372.998260 630.500000,373.004730  C628.934143,373.005096 627.280945,372.680817 626.000000,374.000000  "
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M725.500000,297.000000  C723.887512,298.547821 721.866150,297.978516 720.000000,297.980255  C690.000000,298.008240 660.000000,298.000000 630.000000,298.000000  "
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M609.500000,374.000000  C608.219055,372.680817 606.565857,373.005096 605.000000,373.004730  C576.666687,372.998230 548.333313,372.998230 520.000000,373.004730  C518.434143,373.005096 516.780945,372.680817 515.500000,374.000000  "
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M609.500000,380.000000  C608.219055,378.680817 606.565857,379.005096 605.000000,379.004730  C576.666687,378.998230 548.333313,378.998230 520.000000,379.004730  C518.434143,379.005096 516.780945,378.680817 515.500000,380.000000  "
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M626.500000,338.500000  C656.166687,338.500000 685.833313,338.487000 715.499939,338.534576  C717.156677,338.537231 718.922546,337.941315 720.500000,339.000000  "
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M609.500000,274.000000  C608.219055,272.680817 606.565857,273.005096 605.000000,273.004730  C576.666687,272.998230 548.333313,272.998230 520.000000,273.004730  C518.434143,273.005096 516.780945,272.680817 515.500000,274.000000  "
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M609.500000,375.000000  C608.219055,376.319183 606.565857,375.994904 605.000000,375.995270  C576.666687,376.001770 548.333313,376.001770 520.000000,375.995270  C518.434143,375.994904 516.780945,376.319183 515.500000,375.000000  "
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M609.500000,268.000000  C608.219055,266.680817 606.565857,267.005096 605.000000,267.004730  C576.666687,266.998230 548.333313,266.998230 520.000000,267.004730  C518.434143,267.005096 516.780945,266.680817 515.500000,268.000000  "
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M609.500000,356.000000  C608.219055,354.680817 606.565857,355.005096 605.000000,355.004730  C576.666687,354.998230 548.333313,354.998230 520.000000,355.004730  C518.434143,355.005096 516.780945,354.680817 515.500000,356.000000  "
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M609.500000,269.000000  C608.219055,270.319183 606.565857,269.994904 605.000000,269.995270  C576.666687,270.001770 548.333313,270.001770 520.000000,269.995270  C518.434143,269.994904 516.780945,270.319183 515.500000,269.000000  "
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M723.500000,264.000000  C721.745178,265.030396 719.826965,264.466370 717.999939,264.469147  C689.166687,264.513092 660.333313,264.486633 631.500061,264.534607  C629.843323,264.537384 628.077454,263.941315 626.500000,265.000000  "
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M720.500000,352.000000  C718.922546,353.058685 717.156738,352.462402 715.499939,352.465332  C687.833313,352.513916 660.166687,352.486084 632.500061,352.534668  C630.843262,352.537567 629.077454,351.941315 627.500000,353.000000  "
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M628.000000,281.500000  C657.166687,281.500000 686.333313,281.513214 715.499939,281.465393  C717.156677,281.462677 718.922546,282.058685 720.500000,281.000000  "
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M608.500000,219.000000  C607.646179,217.956192 606.487244,218.532257 605.499939,218.530930  C576.833313,218.492661 548.166687,218.492661 519.500061,218.530945  C518.512756,218.532257 517.353821,217.956192 516.500000,219.000000  "
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M608.500000,339.000000  C607.646179,337.956207 606.487244,338.532257 605.499939,338.530945  C576.833313,338.492645 548.166687,338.492645 519.500061,338.530914  C518.512756,338.532257 517.353821,337.956207 516.500000,339.000000  "
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M608.500000,223.000000  C607.646179,224.043808 606.487244,223.467743 605.499939,223.469070  C576.833313,223.507339 548.166687,223.507339 519.500061,223.469055  C518.512756,223.467743 517.353821,224.043808 516.500000,223.000000  "
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M608.500000,281.000000  C607.646179,282.043793 606.487244,281.467743 605.499939,281.469055  C576.833313,281.507355 548.166687,281.507355 519.500061,281.469086  C518.512756,281.467743 517.353821,282.043793 516.500000,281.000000  "
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M612.500000,352.000000  C611.646179,353.043793 610.487183,352.467834 609.499939,352.469086  C579.500000,352.507019 549.500000,352.507019 519.500061,352.469116  C518.512817,352.467865 517.353821,353.043793 516.500000,352.000000  "
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M612.500000,370.000000  C611.646179,371.043793 610.487183,370.467834 609.499939,370.469086  C579.500000,370.507019 549.500000,370.507019 519.500061,370.469116  C518.512817,370.467865 517.353821,371.043793 516.500000,370.000000  "
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M513.500000,264.000000  C514.537048,265.074158 515.847229,264.464752 517.000061,264.466339  C547.833313,264.508636 578.666687,264.506836 609.499939,264.469116  C610.487183,264.467896 611.646179,265.043793 612.500000,264.000000  "
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M624.000000,357.000000  C626.988220,361.029480 627.565308,366.041290 630.024597,370.500000  C658.166687,370.500000 686.833313,370.513428 715.499939,370.465363  C717.156677,370.462585 718.922546,371.058685 720.500000,370.000000  "
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M466.500000,204.000000  C466.500000,264.500000 466.500000,325.000000 466.500000,385.500000  "
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M323.500000,204.000000  C323.500000,232.166672 323.513672,260.333374 323.465332,288.499939  C323.462494,290.156708 324.058685,291.922546 323.000000,293.500000  "
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1498.500000,393.000000  C1497.033203,391.360321 1495.248413,390.327301 1493.001099,390.513367  C1482.481689,391.384338 1471.994019,390.317627 1461.497681,390.186676  C1423.503540,389.712708 1385.500000,390.011780 1347.500000,389.984039  C1343.094849,389.980804 1338.985474,392.103455 1334.491455,391.572357  C1333.322998,391.434265 1332.403931,391.121552 1331.500000,390.500000  "
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1470.500000,248.000000  C1468.922485,249.058701 1467.155640,248.469940 1465.500122,248.464828  C1426.166626,248.343430 1386.833374,248.170151 1347.500000,247.988159  C1345.786377,247.980225 1343.941284,248.460388 1342.500000,247.000000  "
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M437.500000,471.500000  C409.883484,474.774200 382.160217,472.149506 354.500122,473.003937  C344.499359,473.312836 334.500732,473.693878 324.498993,473.962860  C323.350616,473.993744 322.044159,474.524292 321.000000,473.549194  C321.000000,470.820831 321.000000,468.146210 321.000000,465.605103  C324.166656,464.143951 326.833344,465.911591 329.494446,465.470215  C330.000275,467.999939 330.500153,470.499969 331.000000,473.000000  "
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    d: " M320.000000,162.500000  C321.460388,161.058746 320.977844,159.213638 320.986237,157.499939  C321.019623,150.666763 321.108612,143.830872 320.954132,137.001038  C320.876984,133.591080 322.520233,131.990143 325.449005,133.130936  C328.458221,134.303040 330.521576,132.420517 333.014923,132.126801  C339.135925,131.405716 345.366791,130.809372 351.487244,131.199982  C355.057312,131.427826 358.496185,130.906097 362.000610,130.947922  C384.499390,131.216568 407.054077,130.470612 429.476410,131.876343  C440.143341,132.545090 450.873016,132.118073 461.508087,133.434586  C463.785919,133.716537 466.248138,133.478439 468.473053,132.896896  C470.119659,132.466507 470.053528,130.534988 469.997253,129.000107  C469.838409,124.666481 469.731812,120.329422 469.471619,116.001709  C469.347870,113.943230 469.273315,111.998787 471.000000,110.500000  "
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1194.500000,395.000000  C1193.219116,393.680817 1191.565796,394.005219 1190.000000,394.004761  C1165.666626,393.997955 1141.333374,393.997955 1117.000000,394.004761  C1115.434204,394.005188 1113.780884,393.680817 1112.500000,395.000000  "
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M309.000000,116.000000  C313.396942,116.493523 317.594757,116.653641 322.063263,115.193581  C326.610413,113.707817 331.904907,114.721840 336.444061,115.383682  C343.219635,116.371643 349.864990,115.614655 356.505493,115.783844  C378.824371,116.352478 401.169159,116.176857 423.498016,115.860481  C428.341461,115.791855 432.768402,117.606117 437.500000,117.500000  "
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1092.500000,225.000000  C1093.780884,223.680801 1095.434204,224.005020 1097.000000,224.004700  C1128.000000,223.998367 1159.000000,223.998367 1190.000000,224.004700  C1191.565796,224.005020 1193.219116,223.680801 1194.500000,225.000000  "
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1093.500000,391.000000  C1101.309326,392.293671 1109.171509,391.358093 1117.000610,391.423737  C1141.665527,391.630676 1166.333374,391.504913 1191.000000,391.478760  C1191.833130,391.477875 1192.819092,391.928802 1193.500000,391.000000  "
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1193.500000,397.000000  C1192.819092,397.928802 1191.833130,397.477905 1191.000000,397.478760  C1166.000000,397.504883 1141.000000,397.504852 1116.000000,397.478760  C1115.166870,397.477875 1114.180908,397.928802 1113.500000,397.000000  "
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1348.000000,230.500000  C1372.833374,230.500000 1397.666626,230.484512 1422.499878,230.534790  C1424.156860,230.538147 1425.922485,229.941299 1427.500000,231.000000  "
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1348.000000,424.500000  C1372.833374,424.500000 1397.666626,424.484497 1422.499878,424.534790  C1424.156860,424.538116 1425.922485,423.941315 1427.500000,425.000000  "
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1341.000000,392.000000  C1341.922119,394.838135 1344.240601,394.604034 1347.000000,394.440399  C1347.000000,404.994751 1347.000000,415.497375 1347.000000,426.020599  C1348.772583,426.835022 1350.661621,426.483429 1352.500000,426.485321  C1374.500000,426.508087 1396.500000,426.482574 1418.499878,426.534943  C1420.156982,426.538879 1421.922485,425.941315 1423.500000,427.000000  "
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1348.000000,215.500000  C1373.666626,215.500000 1399.333374,215.500000 1425.000000,215.500000  "
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1462.500000,410.000000  C1424.333374,410.000000 1386.166626,410.000000 1348.000000,410.000000  "
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1348.000000,217.500000  C1373.666626,217.500000 1399.333374,217.500000 1425.000000,217.500000  "
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1348.000000,406.500000  C1371.500000,406.500000 1395.000000,406.516357 1418.499878,406.465149  C1420.156860,406.461548 1421.922485,407.058685 1423.500000,406.000000  "
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1348.000000,232.500000  C1371.500000,232.500000 1395.000000,232.483673 1418.499878,232.534866  C1420.156860,232.538483 1421.922485,231.941299 1423.500000,233.000000  "
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1333.500000,246.500000  C1336.000000,248.845871 1339.042603,247.277878 1340.851685,246.241135  C1342.769043,245.142288 1344.737305,245.360764 1347.000000,244.730011  C1347.000000,234.005295 1347.000000,223.494705 1347.000000,212.500000  C1349.322266,212.500000 1351.161133,212.500000 1353.000000,212.500000  C1374.833374,212.500000 1396.666626,212.517532 1418.499878,212.465012  C1420.156982,212.461029 1421.922485,213.058701 1423.500000,212.000000  "
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1664.000000,410.000000  C1611.333374,410.000000 1558.666626,409.988251 1506.000000,410.049408  C1504.176758,410.051514 1502.043823,409.074066 1500.500000,411.000000  "
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1383.500000,300.500000  C1382.020996,302.482941 1383.732544,304.175842 1383.934082,306.500000  C1391.659424,306.500000 1399.340576,306.500000 1407.250000,306.500000  C1407.250000,310.666656 1407.250000,314.333344 1407.250000,318.500000  C1401.009277,318.500000 1394.974487,318.864685 1389.010620,318.371399  C1385.053345,318.044128 1383.290649,319.512390 1382.500000,323.000000  "
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M917.500000,281.500000  C916.020996,283.482941 917.732544,285.175842 917.934082,287.500000  C925.659424,287.500000 933.340576,287.500000 941.250000,287.500000  C941.250000,291.333344 941.250000,294.666656 941.250000,298.500000  C935.009277,298.500000 928.974487,298.864716 923.010620,298.371460  C919.053284,298.044128 917.290649,299.512390 916.500000,303.000000  "
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M792.500000,328.500000  C789.833313,326.500000 787.233154,324.402313 784.479919,322.529541  C782.089905,320.903839 779.611023,319.109650 780.120605,316.019897  C780.621460,312.983215 781.104858,309.410370 785.495728,308.958557  C787.679565,308.733826 788.749268,306.546570 790.098938,305.402893  C793.024109,306.060669 792.021912,308.580414 793.248169,310.500000  C800.659424,310.500000 808.340576,310.500000 816.250000,310.500000  C816.250000,314.666656 816.250000,318.333344 816.250000,322.500000  C810.009277,322.500000 803.974487,322.864716 798.010620,322.371429  C794.053284,322.044128 792.290649,323.512390 791.500000,327.000000  "
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1563.500000,392.000000  C1561.900024,390.133148 1559.782349,389.970032 1557.499878,389.976105  C1540.833374,390.020416 1524.166626,390.020416 1507.500122,389.976105  C1505.217651,389.970062 1503.099976,390.133148 1501.500000,392.000000  "
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M470.500000,204.000000  C470.500000,250.166672 470.489227,296.333344 470.522552,342.499969  C470.524963,345.833069 470.061859,349.205231 471.000000,352.500000  "
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1595.000000,216.500000  C1564.667114,216.878998 1534.342651,218.016342 1504.000000,217.500000  "
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1565.000000,232.500000  C1544.328003,232.500000 1523.655884,232.500000 1502.983887,232.500000  C1502.981323,231.916672 1502.978760,231.333328 1502.976196,230.750000  C1523.988037,230.750000 1545.000000,230.750000 1566.374023,230.750000  C1565.833008,229.666824 1565.682861,229.050842 1565.497681,229.040100  C1545.008057,227.850311 1524.498779,228.817841 1504.000000,228.500000  "
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1504.000000,416.500000  C1529.500000,416.500000 1555.000000,416.500000 1580.500000,416.500000  "
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1570.000000,432.500000  C1578.666626,432.500000 1587.333374,432.500000 1596.044678,432.500000  C1597.012451,431.272400 1596.621948,428.722565 1596.445312,428.663483  C1593.296021,427.610229 1590.988281,424.310089 1587.504639,424.564270  C1573.737427,425.568817 1560.304810,421.594025 1546.491089,422.332733  C1532.364868,423.088135 1518.166626,422.500000 1504.000000,422.500000  "
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1503.000000,407.500000  C1504.575439,405.748016 1506.655640,406.539551 1508.500122,406.535645  C1533.500000,406.482605 1558.500000,406.515381 1583.499878,406.465240  C1585.156860,406.461914 1586.922485,407.058685 1588.500000,406.000000  "
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1563.500000,216.000000  C1559.204224,214.858185 1554.829224,215.574554 1550.499634,215.543533  C1535.000488,215.432404 1519.500000,215.500000 1504.000000,215.500000  "
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1561.500000,432.500000  C1560.999878,429.955536 1560.274414,427.396088 1562.461060,424.500000  C1542.669556,424.500000 1523.334717,424.500000 1504.000000,424.500000  "
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1490.500000,431.000000  C1494.016357,434.568756 1498.321899,433.796814 1502.479004,432.902344  C1503.852173,432.606903 1505.165527,432.523010 1506.500000,432.520660  C1524.166626,432.489624 1541.833374,432.497711 1559.500000,432.507080  C1560.355591,432.507538 1561.286621,432.233856 1562.225708,433.517914  C1561.747192,437.474792 1561.520996,441.945496 1564.000000,446.000000  "
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1562.000000,213.500000  C1560.424561,211.748001 1558.344727,212.542618 1556.499878,212.536209  C1539.000122,212.475464 1521.500000,212.500000 1504.000000,212.500000  "
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1560.500000,426.500000  C1541.666626,426.500000 1522.833374,426.500000 1504.000000,426.500000  "
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1462.500000,424.500000  C1454.500000,424.500000 1446.497681,424.613647 1438.500977,424.451233  C1434.606323,424.372101 1431.333618,425.410217 1427.896851,427.313812  C1425.522705,428.628784 1425.332275,429.943848 1425.584595,432.307770  C1436.477539,433.075409 1447.529663,431.686829 1458.500000,433.000000  "
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1560.500000,248.000000  C1552.686768,249.110779 1544.829346,248.473801 1537.000366,248.435532  C1526.167847,248.382599 1515.318604,249.127411 1504.500000,248.000000  "
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M276.000000,297.000000  C279.697388,298.896820 283.662415,297.802399 287.501709,297.957550  C291.994385,298.139130 296.500092,297.983398 300.999908,298.012054  C302.080902,298.018921 303.578186,297.500488 303.496368,299.499847  C303.430725,301.104340 302.536530,301.605835 300.998993,301.517303  C294.501343,301.143127 288.001953,300.779053 281.498352,300.545593  C280.189026,300.498596 278.721924,299.941986 277.500000,301.000000  "
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M368.500000,196.000000  C360.018707,197.120667 351.496582,196.451614 343.000183,196.430756  C333.502197,196.407440 323.982666,197.155334 314.500000,196.000000  "
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M475.500000,196.000000  C467.018707,197.120667 458.496582,196.451614 450.000183,196.430756  C440.502197,196.407440 430.982666,197.155334 421.500000,196.000000  "
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M367.500000,389.000000  C366.583191,390.207886 365.260529,389.999298 364.000000,389.999390  C348.333344,390.000336 332.666656,390.000336 317.000000,389.999390  C315.739471,389.999298 314.416809,390.207886 313.500000,389.000000  "
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M476.500000,200.000000  C475.583191,198.792114 474.260529,199.000702 473.000000,199.000626  C457.333344,198.999664 441.666656,198.999680 426.000000,199.000641  C424.739471,199.000717 423.416809,198.792114 422.500000,200.000000  "
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M367.500000,200.000000  C366.583191,198.792114 365.260529,199.000702 364.000000,199.000626  C348.333344,198.999664 332.666656,198.999680 317.000000,199.000641  C315.739471,199.000717 314.416809,198.792114 313.500000,200.000000  "
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M668.500000,563.500000  C669.666687,563.500000 670.833313,563.500000 672.510986,563.500000  C672.430664,542.828491 672.810974,522.157410 671.640930,501.000000  C666.678162,501.000000 661.839050,501.000000 657.000000,501.000000  C643.666687,501.000000 630.333252,500.982117 617.000061,501.020508  C615.133606,501.025909 613.112488,500.452179 611.500000,502.000000  "
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    d: " M769.000000,489.000000  C763.906128,489.300201 760.396179,492.255981 759.500061,497.000000  C758.861633,500.379913 762.280457,506.362946 765.500000,507.499969  C769.696594,508.982086 774.995850,507.215668 777.500000,503.499969  C781.031799,498.259430 776.545837,489.586578 770.000000,489.000000  "
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M708.500000,408.000000  C700.854126,409.123810 693.165894,408.343933 685.499390,408.462219  C675.501770,408.616486 665.500000,408.500000 655.500000,408.500000  "
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M671.500000,469.000000  C666.692505,469.915985 661.833252,469.446136 656.999878,469.473694  C643.666992,469.549805 630.333191,469.525604 617.000183,469.464111  C615.510681,469.457275 613.894592,470.115570 612.500000,469.000000  "
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M605.500000,502.000000  C604.416382,500.667694 602.900452,501.009460 601.500000,501.008453  C583.666687,500.995636 565.833313,500.997162 548.000000,501.014313  C547.488831,501.014801 546.977905,501.227539 546.000000,501.445221  C546.000000,505.151520 546.024048,508.825989 545.991516,512.499939  C545.970276,514.900146 546.776733,516.116577 549.501099,516.076904  C552.145203,516.038330 553.159912,515.157654 553.039001,512.498230  C552.880249,509.005432 553.000000,505.500000 553.000000,502.000000  "
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M759.000000,437.000000  C755.167419,437.183807 751.299744,436.560333 747.500000,437.485168  C747.500000,450.833344 747.500000,464.166656 747.500000,477.500000  "
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M746.500000,437.000000  C745.108276,435.858734 743.482239,436.826660 741.750000,436.393280  C741.750000,450.329315 741.750000,464.164673 741.750000,478.321289  C743.166687,478.532074 744.833313,478.888306 746.500000,478.000000  "
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M546.500000,469.000000  C553.650208,469.874359 560.836243,469.529877 567.999451,469.451111  C580.166077,469.317291 592.346497,470.129608 604.500000,469.000000  "
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1462.500000,230.500000  C1453.833374,230.500000 1445.166504,230.476410 1436.500122,230.522476  C1434.999268,230.530457 1433.373535,230.515625 1432.021484,231.053955  C1425.504761,233.648453 1425.500000,233.762039 1425.500000,241.000000  C1425.500000,243.333328 1425.500000,245.666672 1425.500000,248.000000  "
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M546.000000,517.500000  C544.880066,526.816284 545.737793,536.167603 545.524658,545.500549  C545.391541,551.330811 545.500000,557.166687 545.500000,563.044678  C546.727600,564.012451 548.176636,563.253784 549.500000,563.500000  "
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    d: " M625.000000,229.000000  C621.996094,228.941681 619.202637,229.565506 616.477051,230.954926  C612.904114,232.776245 609.000549,232.656860 605.545105,230.910782  C601.825562,229.031265 598.085266,228.429108 593.999695,228.456360  C578.000427,228.563110 561.898132,229.621368 546.029114,228.179688  C530.639038,226.781540 515.331421,227.558258 500.000214,226.994553  C497.587738,226.905853 495.235229,226.931122 493.500000,229.000000  "
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1298.500000,340.000000  C1296.887451,341.547821 1294.866333,340.974457 1293.000000,340.979553  C1279.166626,341.017303 1265.333374,341.000000 1251.500000,341.000000  "
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1298.500000,364.000000  C1296.887451,362.452179 1294.866333,363.025543 1293.000000,363.020447  C1279.166626,362.982697 1265.333374,363.000000 1251.500000,363.000000  "
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1311.500000,379.500000  C1291.500000,379.333344 1271.500000,379.166656 1251.500000,379.000000  "
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1297.500000,360.000000  C1288.350830,361.130066 1279.165894,360.269562 1269.999390,360.473846  C1263.835815,360.611176 1257.666626,360.500000 1251.500000,360.500000  "
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1297.500000,344.000000  C1288.350830,342.869934 1279.165894,343.730408 1269.999390,343.526154  C1263.835815,343.388824 1257.666626,343.500000 1251.500000,343.500000  "
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M780.750000,222.000000  C775.285889,218.212265 769.271545,220.752365 763.500000,220.485550  C763.500000,235.333328 763.500000,250.166672 763.500000,265.000000  "
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1297.500000,376.000000  C1288.350830,377.130066 1279.165894,376.269592 1269.999390,376.473846  C1263.835815,376.611176 1257.666626,376.500000 1251.500000,376.500000  "
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1241.500000,341.000000  C1228.333374,341.000000 1215.166626,341.018097 1202.000000,340.979492  C1200.133667,340.974030 1198.112549,341.547821 1196.500000,340.000000  "
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1241.500000,379.000000  C1228.333374,379.000000 1215.166626,378.981903 1202.000000,379.020508  C1200.133667,379.025970 1198.112549,378.452179 1196.500000,380.000000  "
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M29.000000,208.000000  C29.867601,206.440186 30.311220,204.795578 29.806295,202.750000  C26.000000,202.750000 22.000000,202.750000 17.750000,202.750000  C17.750000,206.666672 17.750000,210.333328 17.750000,214.250000  C22.000000,214.250000 26.000000,214.250000 29.980074,214.250000  C30.138794,212.141693 29.502106,210.516037 28.500000,209.000000  "
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1241.500000,363.000000  C1228.333374,363.000000 1215.166626,362.981903 1202.000000,363.020508  C1200.133667,363.025970 1198.112549,362.452179 1196.500000,364.000000  "
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M764.500000,422.500000  C762.563843,422.878906 761.632202,423.975403 762.071838,426.250000  C765.666687,426.250000 769.333313,426.250000 773.250000,426.250000  C773.250000,422.000000 773.250000,418.000000 773.250000,413.750000  C769.333313,413.750000 765.666687,413.750000 761.958191,413.750000  C761.341919,417.000000 761.122131,420.000000 762.000000,423.000000  "
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M590.500000,408.000000  C581.851868,409.130676 573.165833,408.276489 564.499390,408.472076  C558.169250,408.614929 551.833313,408.500000 545.500000,408.500000  "
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M268.500000,75.500000  C268.451233,76.911926 266.442932,77.017517 266.939270,78.985527  C269.589081,80.140625 272.815643,79.169380 276.250000,79.647385  C276.250000,75.000000 276.250000,71.000000 276.250000,66.750000  C272.333344,66.750000 268.666656,66.750000 264.110382,66.750000  C265.527710,70.983803 262.726898,75.244980 266.000000,79.000000  "
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M765.500000,221.000000  C765.500000,235.666672 765.500000,250.333328 765.500000,265.000000  "
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1241.500000,360.500000  C1228.333374,360.500000 1215.166504,360.525909 1202.000122,360.464111  C1200.510620,360.457123 1198.894531,361.115570 1197.500000,360.000000  "
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M801.500000,391.500000  C792.333313,391.500000 783.166260,391.551544 774.000244,391.470764  C770.975891,391.444122 768.564270,392.295227 766.743530,394.961487  C768.651550,397.984772 771.347656,398.731262 774.500000,398.500000  "
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M771.500000,221.000000  C771.500000,235.666672 771.500000,250.333328 771.500000,265.000000  "
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1241.500000,376.500000  C1228.333374,376.500000 1215.166504,376.525909 1202.000122,376.464111  C1200.510620,376.457123 1198.894531,377.115570 1197.500000,376.000000  "
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1241.500000,343.500000  C1228.333374,343.500000 1215.166504,343.474091 1202.000122,343.535889  C1200.510620,343.542877 1198.894531,342.884430 1197.500000,344.000000  "
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M768.500000,221.000000  C768.500000,234.166672 768.634216,247.335526 768.418030,260.498657  C768.353333,264.435944 769.401978,266.216522 773.503052,265.517822  C775.479919,265.181000 777.573547,266.049225 779.500000,265.000000  "
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M321.000000,70.500000  C319.853027,68.408745 320.878601,66.150368 320.366882,63.750000  C317.015869,63.750000 313.507935,63.750000 309.575104,63.750000  C309.245300,70.481804 309.978912,77.559456 308.555145,84.511299  C308.199402,86.248322 308.189240,88.226555 310.000000,89.500000  "
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1074.500000,225.000000  C1074.500000,239.333328 1074.500000,253.666672 1074.500000,268.222351  C1079.617798,266.566406 1084.325806,271.279022 1089.500000,269.000000  "
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1078.500000,225.000000  C1078.500000,239.166672 1078.500000,253.333328 1078.500000,267.500000  "
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1076.500000,225.000000  C1076.500000,239.166672 1076.500000,253.333328 1076.500000,267.500000  "
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1581.500000,129.500000  C1581.500000,169.000000 1581.500000,208.500000 1581.500000,248.000000  "
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1441.500000,129.500000  C1441.500000,162.500000 1441.500000,195.500000 1441.500000,228.500000  C1448.500000,228.500000 1455.500000,228.500000 1462.500000,228.500000  "
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M30.500000,415.500000  C30.500000,413.999237 30.500000,412.498474 30.500000,410.750000  C26.333334,410.750000 22.666666,410.750000 18.750000,410.750000  C18.750000,414.666656 18.750000,418.333344 18.750000,422.250000  C22.666666,422.250000 26.333334,422.250000 30.500000,422.250000  C30.500000,420.501526 30.500000,419.000763 30.500000,417.500000  "
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M481.000000,499.500000  C483.962616,502.830841 482.904205,507.046753 482.254669,510.453217  C481.318726,515.361816 481.927673,520.173157 481.392700,525.250000  C477.681152,525.250000 473.840576,525.250000 469.793091,525.250000  C469.559540,523.851379 469.279755,522.175720 468.999969,520.500000  "
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1081.500000,225.000000  C1081.500000,237.500000 1081.523926,250.000107 1081.464722,262.499847  C1081.458496,263.821716 1082.057983,265.278076 1081.000000,266.500000  "
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M310.000000,499.500000  C307.037384,502.830841 308.095764,507.046783 308.745270,510.453217  C309.681244,515.361816 309.072327,520.173157 309.607300,525.250000  C312.984131,525.250000 316.492065,525.250000 320.206909,525.250000  C320.440430,523.851379 320.720215,522.175720 321.000000,520.500000  "
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M276.000000,493.000000  C274.919525,493.088074 273.470978,492.499634 273.491364,494.500092  C273.523712,497.675171 273.500000,500.850830 273.500000,504.250000  C277.666656,504.250000 281.333344,504.250000 285.250000,504.250000  C285.250000,500.333344 285.250000,496.666656 285.250000,492.886169  C282.993652,493.107788 280.977600,493.191040 279.004639,493.527313  C276.261749,493.994751 276.311859,492.351227 276.500000,490.500000  "
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1090.000000,227.000000  C1088.930420,232.305115 1089.518799,237.671906 1089.559814,242.999542  C1089.620361,250.831985 1088.889282,258.686768 1090.000000,266.500000  "
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1197.000000,227.500000  C1197.822021,240.500000 1197.822021,253.500000 1197.000000,266.500000  "
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1301.000000,227.500000  C1301.822021,240.500000 1301.822021,253.500000 1301.000000,266.500000  "
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1298.000000,227.500000  C1297.177979,240.500000 1297.177979,253.500000 1298.000000,266.500000  "
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 15,
    d: " M404.000000,390.000000  C404.802551,395.830139 409.416260,396.961884 414.005127,397.976807  C419.602753,399.214813 425.309082,399.062134 431.000061,399.005646  C434.166412,398.974213 437.378204,399.343109 440.491638,398.936066  C450.087982,397.681427 458.762756,400.914368 467.500000,404.000000  "
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1194.000000,227.500000  C1193.177979,240.500000 1193.177979,253.500000 1194.000000,266.500000  "
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1076.500000,272.500000  C1074.007080,271.872314 1074.507690,273.671906 1074.506348,275.000000  C1074.495239,286.333344 1074.500000,297.666656 1074.500000,309.000000  "
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M780.000000,223.000000  C778.871216,228.638367 779.534485,234.338501 779.565308,239.999649  C779.604370,247.164459 778.877686,254.355560 780.000000,261.500000  "
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M906.000000,223.500000  C906.833191,236.166672 906.833191,248.833328 906.000000,261.500000  "
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M904.000000,223.500000  C903.166809,236.166672 903.166809,248.833328 904.000000,261.500000  "
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M327.500000,134.500000  C326.372559,140.808044 327.246643,147.168228 327.023468,153.500824  C326.894409,157.162949 327.073181,160.835190 326.979828,164.499481  C326.882629,168.315201 327.734802,172.155838 324.643066,175.627411  C323.114075,177.344208 323.403900,180.442749 323.500000,183.000000  "
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1028.000000,223.500000  C1027.166870,236.166672 1027.166870,248.833328 1028.000000,261.500000  "
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1030.000000,223.500000  C1030.833130,236.166672 1030.833130,248.833328 1030.000000,261.500000  "
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M905.500000,303.000000  C904.053589,304.918701 901.959473,304.492584 900.000000,304.494873  C890.333313,304.506134 880.615784,305.113251 871.015198,304.316650  C862.491638,303.609375 853.817444,304.685059 845.561218,303.166931  C839.197449,301.996857 834.275391,303.684448 829.000000,306.000000  "
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1665.000000,237.500000  C1663.627319,235.371719 1664.981201,233.470657 1665.533081,231.384079  C1664.904053,229.954681 1663.551147,230.524506 1662.500000,230.523041  C1640.666626,230.492477 1618.833374,230.494431 1597.000000,230.521286  C1596.166870,230.522324 1595.180908,230.071182 1594.500000,231.000000  "
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M681.500000,401.000000  C674.189209,399.840942 666.832092,400.752747 659.499512,400.515747  C647.836914,400.138702 636.152710,401.145477 624.500000,400.000000  "
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M462.500000,134.500000  C463.642822,142.479660 462.717041,150.502029 462.983826,158.500534  C463.083771,161.497208 462.920166,164.502716 463.022339,167.499237  C463.125580,170.527939 462.298248,173.279022 458.996521,173.362747  C455.838928,173.442795 455.761047,170.396515 455.513550,167.998596  C455.428436,167.174057 455.500000,166.333328 455.500000,165.500000  "
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M831.000000,307.000000  C832.603210,307.801270 834.325562,307.486938 836.000000,307.488373  C856.833313,307.506165 877.666748,307.481659 898.499939,307.535065  C900.156921,307.539307 901.922546,306.941315 903.500000,308.000000  "
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1078.000000,273.000000  C1079.130981,279.475281 1078.297607,286.000824 1078.469849,292.500793  C1078.615845,298.001953 1078.500000,303.510101 1078.500000,309.159790  C1076.890381,308.790588 1076.479370,308.142426 1076.482422,306.999939  C1076.511719,296.000031 1076.500000,285.000000 1076.500244,274.000000  C1076.500244,273.278534 1076.331787,272.443390 1077.500000,272.500000  "
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M476.500000,389.000000  C475.583191,390.207886 474.260529,389.999298 473.000000,389.999390  C457.333344,390.000366 441.666656,390.000366 426.000000,389.999390  C424.739471,389.999329 423.416809,390.207886 422.500000,389.000000  "
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1081.500000,273.000000  C1081.500000,283.000000 1081.487671,293.000031 1081.511963,302.999969  C1081.516113,304.674561 1081.198730,306.396790 1082.000000,308.000000  "
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1715.500000,244.500000  C1707.170776,243.740845 1699.211060,246.602707 1691.000000,246.999268  C1685.993774,247.241043 1680.958862,246.472763 1675.968628,247.889679  C1674.510864,248.303604 1672.684326,247.376831 1671.500000,246.000000  "
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M828.000000,307.000000  C821.189270,308.093719 814.332397,307.288391 807.499329,307.474548  C802.669556,307.606140 797.833313,307.500000 793.000000,307.500000  "
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M465.000000,546.000000  C462.666656,546.000000 460.322937,545.861694 458.002747,546.036438  C455.348114,546.236389 453.628815,548.086670 453.628815,550.500000  C453.628815,552.913330 455.347931,554.773804 458.002686,554.962097  C460.501129,555.139221 463.022034,555.000000 466.000000,555.000000  C466.000000,548.843140 466.000000,543.171570 466.000000,537.500000  "
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M791.500000,305.500000  C794.702698,303.860443 798.152466,304.570129 801.500366,304.528351  C808.832520,304.436798 816.166687,304.493683 823.500000,304.505035  C825.065918,304.507446 827.213440,303.961060 827.914368,305.538055  C830.946106,312.358307 838.101196,314.387573 842.999329,319.000702  C843.170898,319.162170 843.333313,319.333344 843.500000,319.500000  "
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1667.500000,392.000000  C1666.157959,390.521759 1664.497314,389.965271 1662.499878,389.978333  C1654.500244,390.030731 1646.499756,390.030731 1638.500122,389.978363  C1636.502686,389.965271 1634.842041,390.521759 1633.500000,392.000000  "
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1597.000000,217.500000  C1619.333374,217.500000 1641.666626,217.500000 1664.000000,217.500000  "
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M760.000000,437.500000  C761.177612,452.015442 760.077637,466.504730 760.717468,481.506775  C767.851990,481.132751 776.251953,482.466125 784.500000,480.000000  "
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M345.000000,81.500000  C347.225525,84.316177 344.169312,86.691940 344.325623,89.509674  C344.804932,98.149750 344.500000,106.833336 344.500000,115.500000  "
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1629.000000,443.500000  C1627.257568,440.071655 1626.632812,428.514740 1628.203247,424.477539  C1616.833374,424.845062 1605.666626,423.835175 1594.500000,425.000000  "
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M309.000000,405.500000  C312.187317,412.738434 311.488129,420.410950 311.495667,428.000000  C311.510376,442.833344 311.500000,457.666656 311.500000,472.500000  "
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M344.500000,474.000000  C344.500000,481.666656 344.444946,489.333984 344.532501,496.999634  C344.559845,499.391876 343.846466,501.903046 345.902100,504.091949  C346.528839,504.759338 346.207886,506.583191 345.000000,507.500000  "
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M755.500000,267.500000  C754.058716,268.960388 752.213501,268.481201 750.499939,268.486450  C741.166748,268.514984 731.833313,268.500000 722.500000,268.500000  "
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M311.500000,117.000000  C311.500000,127.333336 310.953613,137.704697 311.669159,147.988235  C312.264618,156.545685 311.462982,165.000671 311.537231,173.499680  C311.567383,176.948318 309.116211,179.959106 310.000000,183.500000  "
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M755.500000,373.500000  C754.058716,374.960388 752.213501,374.481201 750.499939,374.486450  C741.166748,374.514984 731.833313,374.500000 722.500000,374.500000  "
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1597.000000,215.500000  C1606.333374,215.500000 1615.666626,215.486923 1625.000000,215.512115  C1626.674561,215.516632 1628.396851,215.198730 1630.000000,216.000000  "
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M682.500000,404.000000  C681.058716,405.460388 679.213623,404.978729 677.499939,404.986267  C670.166748,405.018494 662.833313,404.991180 655.500000,405.006073  C653.614014,405.009888 651.655945,404.691162 650.000000,406.000000  "
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1664.500000,425.000000  C1665.804688,419.222168 1664.137695,413.274536 1665.608643,407.074982  C1664.240479,406.084656 1662.540405,406.522217 1661.000000,406.519775  C1641.833374,406.489532 1622.666626,406.519928 1603.500122,406.464844  C1601.843018,406.460114 1600.077515,407.058685 1598.500000,406.000000  "
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1664.500000,232.500000  C1644.166626,232.500000 1623.833374,232.481201 1603.500122,232.535080  C1601.843018,232.539459 1600.077515,231.941299 1598.500000,233.000000  "
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1629.500000,392.000000  C1627.900024,390.133148 1625.782349,389.970062 1623.499878,389.976135  C1606.833374,390.020416 1590.166626,390.020447 1573.500122,389.976135  C1571.217651,389.970062 1569.099976,390.133148 1567.500000,392.000000  "
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M720.500000,232.000000  C720.500000,242.666672 720.500000,253.333328 720.500000,264.000000  "
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M367.500000,202.000000  C366.058746,203.460388 364.213470,202.981750 362.499969,202.986481  C352.500031,203.014084 342.481537,202.640793 332.507904,203.153763  C327.628906,203.404709 322.833191,203.001450 318.000092,202.980621  C316.454437,202.973969 314.742767,203.490875 313.500000,202.000000  "
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M476.500000,202.000000  C472.305664,204.729874 467.050446,203.878601 463.034363,203.562912  C450.823090,202.603058 438.660339,203.564545 426.500000,203.000000  C425.099579,202.934967 423.583588,203.332306 422.500000,202.000000  "
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M335.500000,132.500000  C335.500000,143.000000 335.500000,153.500000 335.499756,164.000107  C336.659821,163.797668 337.820129,163.595139 339.500000,163.301910  C339.500000,167.987656 339.500000,172.493820 339.500000,177.000000  "
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M309.000000,441.500000  C308.249969,442.361115 307.967560,443.335754 307.981537,444.500214  C308.175446,460.666565 308.349731,476.833221 308.472137,493.000214  C308.483215,494.464478 308.963745,495.563141 310.000000,496.500000  "
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M483.000000,464.000000  C484.829926,462.632660 483.936371,460.676453 483.958923,458.999451  C484.055359,451.830200 484.000000,444.658905 484.000000,437.085297  C480.106720,436.913513 477.667511,439.030212 475.000000,440.500000  "
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M330.500000,385.000000  C331.780914,386.319183 333.434113,385.993286 335.000000,385.995026  C344.166656,386.005188 353.333405,385.984772 362.499969,386.013580  C364.213501,386.018951 366.058746,385.539612 367.500000,387.000000  "
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M267.000000,372.000000  C265.678925,373.226318 265.668701,374.889557 265.387421,376.814331  C269.598206,379.205231 271.150513,384.419983 275.919861,386.669861  C277.669800,387.495361 279.198669,387.990540 281.000000,387.993073  C291.166656,388.007416 301.333344,388.000000 311.500000,388.000000  C311.500000,383.833344 311.479156,379.666504 311.507965,375.500061  C311.524780,373.068054 311.315552,370.992950 308.000000,372.500000  "
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M608.500000,232.500000  C608.500000,243.000000 608.500000,253.500000 608.500000,264.000000  "
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M867.500000,305.000000  C867.500000,307.677002 867.500000,310.354004 867.500000,313.500000  C860.675415,313.500000 854.332031,313.658905 848.002380,313.432648  C844.855713,313.320190 842.986938,314.067017 843.000000,317.500000  "
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M754.500000,302.000000  C755.309204,300.937683 757.306641,301.301331 757.521912,299.409363  C757.202515,297.595001 755.729065,298.008087 754.500000,298.005707  C748.166687,297.993439 741.833191,298.020905 735.500061,297.986206  C733.786316,297.976837 731.941284,298.460388 730.500000,297.000000  "
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M310.000000,92.500000  C308.454865,93.651627 308.501648,95.304382 308.485748,96.999863  C308.343506,112.166756 308.155334,127.333229 308.015747,142.500137  C307.999969,144.212326 307.539612,146.058746 309.000000,147.500000  "
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M382.500000,534.000000  C382.500000,531.000000 382.500000,528.000000 382.500000,524.750000  C378.346649,524.750000 374.173340,524.750000 369.500000,524.750000  C369.500000,527.649170 369.500000,530.824585 369.500000,534.000000  "
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M491.500000,233.000000  C491.500000,243.333328 491.500000,253.666672 491.500000,264.000000  C491.249573,265.749573 485.750854,262.250854 488.500000,267.000000  "
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M428.000000,399.500000  C428.877563,402.283722 426.878448,405.109985 429.715637,408.256409  C432.238831,411.054749 434.405121,411.469513 437.499359,411.531464  C443.166565,411.644958 448.857391,411.015167 454.500000,412.000000  "
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1664.000000,215.000000  C1656.687988,216.103729 1649.328247,215.162125 1642.001221,215.524078  C1639.167725,215.664062 1636.277588,214.885696 1633.500000,216.000000  "
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M454.500000,133.500000  C454.500000,143.666672 454.500000,153.833328 454.500244,164.000092  C453.340179,163.797653 452.179871,163.595123 450.500000,163.301895  C450.500000,167.987656 450.500000,172.493820 450.500000,177.000000  "
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M332.500000,133.000000  C332.811005,143.164307 331.861511,153.349258 333.000000,163.500000  "
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1093.000000,227.500000  C1093.822266,240.500000 1093.822510,253.500000 1093.000000,266.500000  "
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M714.000000,408.500000  C715.092529,409.534393 714.195801,410.852997 714.610840,412.266937  C705.528870,413.112000 696.464722,411.714752 687.500000,413.000000  "
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M767.500000,271.500000  C769.560059,282.447662 768.029114,293.504181 768.500000,304.500000  "
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M445.000000,85.500000  C446.138489,95.650734 445.188995,105.835701 445.500000,116.000000  "
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M803.500000,221.000000  C803.500000,224.333328 803.500000,227.666672 803.500000,231.500000  C796.674805,231.500000 789.837402,231.500000 783.000000,231.500000  "
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M317.000000,441.500000  C318.138489,451.650726 317.188995,461.835693 317.500000,472.000000  "
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M489.500000,234.000000  C489.500000,244.000000 489.500000,254.000000 489.500000,264.000000  "
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M780.000000,271.500000  C779.180115,281.500000 779.180115,291.500000 780.000000,301.500000  "
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M482.000000,90.500000  C484.213074,95.886078 483.078278,101.547150 482.813263,106.990913  C482.551636,112.365860 482.509979,117.818443 483.237061,122.966522  C484.515656,132.019882 483.375793,141.010773 484.152313,150.277222  C481.999664,150.408890 479.982849,150.532257 476.745209,150.730286  C479.547028,152.453979 481.501984,152.786194 483.500000,153.000000  "
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M469.000000,123.000000  C457.176117,123.838699 445.334106,123.387695 433.500000,123.500000  "
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M782.000000,271.500000  C782.819885,281.500000 782.819885,291.500000 782.000000,301.500000  "
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1194.000000,275.500000  C1193.180176,285.500000 1193.180176,295.500000 1194.000000,305.500000  "
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1093.000000,275.500000  C1093.819824,285.500000 1093.819824,295.500000 1093.000000,305.500000  "
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1090.000000,275.500000  C1089.180176,285.500000 1089.180176,295.500000 1090.000000,305.500000  "
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1076.500000,312.500000  C1074.766724,312.100037 1074.421753,312.762268 1074.445557,314.500732  C1074.564453,323.165771 1074.500000,331.833344 1074.500000,340.545898  C1075.541748,341.541168 1076.845825,340.746155 1078.000000,341.025818  C1078.000000,331.488312 1078.000000,321.985382 1078.000000,312.482452  C1077.500000,312.476410 1077.000000,312.470337 1076.500000,312.464294  C1076.500000,321.809509 1076.500000,331.154755 1076.500000,340.500000  "
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M466.500000,133.500000  C466.197083,143.497726 467.120422,153.515900 466.000000,163.500000  "
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1028.000000,271.500000  C1027.180176,281.500000 1027.180176,291.500000 1028.000000,301.500000  "
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M323.500000,133.500000  C323.802917,143.497726 322.879578,153.515900 324.000000,163.500000  "
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M468.000000,465.000000  C458.349518,463.894318 448.664337,464.631378 439.000183,464.644623  C437.242798,464.647003 435.326782,464.761383 433.500000,465.000000  "
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M457.500000,133.500000  C457.197083,143.497726 458.120422,153.515900 457.000000,163.500000  "
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1030.000000,271.500000  C1030.819824,281.500000 1030.819824,291.500000 1030.000000,301.500000  "
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1197.000000,275.500000  C1197.819824,285.500000 1197.819824,295.500000 1197.000000,305.500000  "
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M445.500000,472.500000  C445.197083,482.497742 446.120422,492.515900 445.000000,502.500000  "
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1298.000000,275.500000  C1297.180176,285.500000 1297.180176,295.500000 1298.000000,305.500000  "
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M369.500000,55.500000  C369.500000,58.333332 369.500000,61.166668 369.500000,64.250000  C373.653351,64.250000 377.826660,64.250000 382.500000,64.250000  C382.500000,61.518494 382.500000,58.509247 382.500000,55.500000  "
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M249.500000,422.000000  C250.897247,421.929199 252.732849,422.588501 252.512009,419.998962  C252.256714,417.005432 252.981415,413.954742 251.938446,410.750000  C248.333328,410.750000 244.666672,410.750000 240.942154,410.750000  C241.321289,416.286957 243.958191,419.809631 249.000000,421.500000  "
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1301.000000,275.500000  C1301.819824,285.500000 1301.819824,295.500000 1301.000000,305.500000  "
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M782.000000,223.500000  C782.824280,236.166672 782.836182,248.833328 782.000000,261.500000  "
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M455.500000,412.500000  C455.088898,427.164886 453.998932,441.814362 454.500000,456.500000  "
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M606.500000,411.500000  C607.685242,411.413452 608.796631,411.450073 609.113647,413.516083  C599.166687,412.069214 589.333313,412.166901 579.500000,413.000000  "
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1626.500000,170.000000  C1619.189209,168.840942 1611.828125,169.525803 1604.500366,169.568512  C1593.167969,169.634537 1581.818726,168.842133 1570.500000,170.000000  "
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M456.500000,469.500000  C449.591278,477.308899 452.084229,486.587799 452.549713,495.497406  C452.772064,499.753387 456.479828,498.644043 459.004852,498.961517  C466.043701,499.846527 472.964081,497.578918 480.000000,498.000000  "
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M460.500000,385.000000  C457.491486,386.835846 454.174133,385.916626 450.999451,385.960236  C442.501068,386.076935 433.999908,386.017670 425.500092,385.979370  C424.336639,385.974121 423.361115,386.249969 422.500000,387.000000  "
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1570.500000,248.000000  C1577.644531,249.116455 1584.838379,248.483994 1591.999512,248.435669  C1603.499023,248.358078 1615.014038,249.131851 1626.500000,248.000000  "
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M510.500000,409.500000  C510.000702,411.999298 511.006439,412.550751 513.498962,412.582703  C521.498474,412.685272 529.520508,411.850403 537.500000,413.000000  "
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1113.500000,225.000000  C1113.500000,228.333328 1113.500000,231.666672 1113.500000,235.500000  C1107.008545,235.500000 1100.504272,235.500000 1094.000000,235.500000  "
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M330.500000,134.000000  C330.190063,143.830902 331.124329,153.682892 330.000000,163.500000  "
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1245.500000,114.000000  C1245.500000,113.000000 1245.500000,112.000000 1245.500000,110.750000  C1242.015869,110.750000 1238.507935,110.750000 1234.750000,110.750000  C1234.750000,114.318848 1234.750000,118.159424 1234.750000,122.500000  C1237.984131,122.500000 1241.492065,122.500000 1245.500000,122.500000  C1245.500000,120.844063 1245.500000,119.172028 1245.500000,117.500000  "
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M317.500000,117.500000  C317.183716,127.164085 318.150879,136.850296 317.000000,146.500000  "
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M764.000000,275.500000  C762.741577,282.975739 763.809753,290.502106 763.552673,298.001801  C763.472656,300.334259 762.944275,302.841278 764.564697,305.056854  C766.253906,295.733826 764.661743,286.288422 766.000000,277.000000  "
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1636.500000,426.500000  C1645.836304,426.500000 1655.172607,426.500000 1664.508911,426.500000  C1664.521484,426.028473 1664.533936,425.556915 1664.546509,425.085388  C1654.759277,423.678406 1644.832397,425.017914 1634.797363,424.363373  C1636.139893,427.166656 1636.754272,429.833344 1635.000000,432.500000  "
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M781.000000,451.500000  C781.000000,461.000000 781.000000,470.500000 781.000000,480.000000  "
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M466.500000,427.000000  C466.500000,436.500000 466.500000,446.000000 466.500000,455.500000  "
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M323.500000,427.000000  C323.500000,436.500000 323.500000,446.000000 323.500000,455.500000  "
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M464.000000,411.000000  C461.859924,411.774048 461.539551,413.336151 461.421692,415.495728  C460.953522,424.074249 463.963135,432.393860 463.048950,441.005188  C462.556824,445.640839 463.493195,450.362854 462.500000,455.000000  "
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M487.500000,45.500000  C487.500000,40.663700 487.500000,35.827400 487.500000,30.750000  C483.333344,30.750000 479.666656,30.750000 475.485352,30.750000  C477.260681,34.895393 478.090118,38.772034 475.500000,42.500000  "
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M460.000000,135.000000  C459.174835,144.500000 459.174866,154.000000 460.000000,163.500000  "
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M407.500000,55.000000  C397.182739,53.836224 386.832428,54.759701 376.499237,54.535603  C368.336426,54.358570 360.166656,54.500000 351.736694,54.500000  C350.882202,61.127445 352.228149,67.878075 351.000000,74.500000  "
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M588.500000,200.500000  C586.296204,204.810684 585.786499,209.309616 587.039062,214.250000  C590.666687,214.250000 594.333313,214.250000 598.112305,214.250000  C597.277466,208.469925 595.473328,203.824844 589.000000,203.000000  "
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M337.000000,474.500000  C338.888092,481.257477 337.804840,488.165039 337.937866,495.001221  C338.024567,499.454315 334.047333,498.584076 331.490143,498.926331  C324.635284,499.843658 317.858765,497.811829 311.000000,498.000000  "
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M303.000000,329.500000  C304.356781,327.047913 302.783661,326.931061 301.000061,327.001495  C294.335754,327.264709 287.652374,326.474426 280.991364,327.440338  C279.900452,327.598511 278.537018,328.074158 277.500000,327.000000  "
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M1596.500000,248.000000  C1596.500000,245.666672 1596.625366,243.324570 1596.463257,241.002563  C1596.312012,238.835922 1597.624878,235.928925 1595.890991,234.647598  C1592.912598,232.446594 1589.721191,230.258957 1585.497192,230.432495  C1579.174561,230.692245 1572.833374,230.500000 1566.500000,230.500000  "
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M756.500000,373.000000  C756.883118,372.540039 757.266174,372.080078 758.214905,370.940887  C748.907043,369.722137 740.117188,371.357117 731.500000,370.000000  "
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1664.500000,248.000000  C1655.166626,248.816620 1645.833374,248.816620 1636.500000,248.000000  "
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M756.500000,355.000031  C756.883118,354.540039 757.266174,354.080078 758.214966,352.940918  C748.907043,351.722137 740.117188,353.357117 731.500000,352.000000  "
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M756.500000,267.000000  C756.883118,266.540039 757.266235,266.080109 758.215149,264.940918  C748.907043,263.722137 740.117188,265.357117 731.500000,264.000000  "
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12,
    d: " M788.500000,448.500000  C788.500000,457.833344 788.500000,467.166656 788.500000,476.500000  "
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1628.000000,213.500000  C1625.184448,211.506714 1622.002563,212.721863 1618.997559,212.539185  C1612.174805,212.124390 1605.310547,213.100159 1598.500000,212.000000  "
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1325.500000,312.000000  C1328.157471,308.783936 1325.657104,309.001770 1323.500000,309.000854  C1317.500000,308.998322 1311.499878,309.021820 1305.500122,308.986176  C1303.786255,308.976013 1301.941284,309.460388 1300.500000,308.000000  "
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M334.500000,412.500000  C334.848541,426.666321 336.021942,440.813202 335.500000,455.000000  "
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M202.500000,200.500000  C204.703812,204.810684 205.213516,209.309616 203.960922,214.250000  C200.333328,214.250000 196.666672,214.250000 192.887711,214.250000  C193.722504,208.469925 195.526657,203.824844 202.000000,203.000000  "
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M304.000000,390.000000  C300.593903,393.199493 296.658447,390.463989 292.992035,390.938324  C287.365112,391.666351 281.563324,389.909607 276.000000,392.000000  "
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1626.500000,426.500000  C1617.169189,426.805542 1607.816284,425.880066 1598.500000,427.000000  "
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M342.500000,393.000000  C333.166656,392.183380 323.833344,392.183380 314.500000,393.000000  "
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M326.000000,411.000000  C328.140076,411.774048 328.460449,413.336151 328.578278,415.495728  C329.046448,424.074249 326.012543,432.396057 326.959991,441.004395  C327.452118,445.475739 326.442657,450.032990 327.500000,454.500000  "
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1081.500000,313.000000  C1081.500000,322.166656 1081.500000,331.333344 1081.500000,340.500000  "
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M367.000000,400.000000  C366.448364,401.396729 365.440796,401.608368 363.997986,401.549561  C360.337402,401.400452 356.584381,401.003479 353.015717,401.594818  C343.049316,403.246277 332.781738,402.336792 322.946259,405.322937  C321.606476,405.729736 319.549957,403.797058 317.498779,403.986847  C311.999786,404.495514 306.494904,404.940277 301.037109,405.406586  C301.227325,404.009583 301.430969,402.513947 301.671539,400.747040  C293.867706,399.875885 286.124268,401.308502 278.500000,400.000000  "
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M303.000000,372.500000  C304.555725,369.610962 302.112610,370.540436 300.999725,370.529968  C294.500305,370.468842 287.999451,370.543884 281.500458,370.463531  C280.176697,370.447144 278.721924,371.058014 277.500000,370.000000  "
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1113.000000,390.500000  C1113.000000,388.333344 1113.000000,386.166656 1113.000000,383.500000  C1106.007935,383.500000 1099.003906,383.500000 1092.000000,383.500000  "
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M303.000000,266.500000  C304.555725,263.610962 302.112610,264.540466 300.999725,264.529968  C294.500305,264.468842 287.999451,264.543884 281.500458,264.463531  C280.176697,264.447174 278.721924,265.058014 277.500000,264.000000  "
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M505.000000,405.500000  C504.316071,407.091949 503.545013,408.612244 506.500641,408.520386  C517.163940,408.188934 527.848389,409.128815 538.500000,408.000000  "
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1635.000000,213.500000  C1637.986694,211.457504 1641.348511,212.568481 1644.499634,212.582047  C1650.997437,212.610031 1657.524780,211.869003 1664.000000,213.000000  "
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M311.000000,91.000000  C317.207581,91.423798 323.273254,89.255257 329.500610,89.994743  C331.921661,90.282242 334.349731,90.510735 337.128418,90.803368  C338.326477,98.900948 338.755951,106.813972 337.000000,114.750000  "
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M303.000000,354.500000  C304.555725,351.610962 302.112610,352.540436 300.999725,352.529968  C294.500305,352.468842 287.999451,352.543884 281.500458,352.463531  C280.176697,352.447144 278.721924,353.058014 277.500000,352.000000  "
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M755.000000,228.000000  C756.000305,230.111298 755.672241,231.112503 752.998840,231.045288  C747.169250,230.898727 741.333191,230.977692 735.500061,231.013824  C733.786255,231.024445 731.941284,230.539612 730.500000,232.000000  "
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M1111.500000,395.500000  C1102.333374,395.500000 1093.166504,395.528961 1084.000122,395.485779  C1080.319336,395.468414 1077.362061,396.376495 1076.500000,400.500000  "
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M755.000000,376.500000  C756.356812,378.952087 754.784180,379.015137 752.999939,379.008362  C747.166748,378.986145 741.333191,378.977661 735.500061,379.013794  C733.786255,379.024414 731.941284,378.539612 730.500000,380.000000  "
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1702.500000,398.000000  C1693.500000,398.000000 1684.500000,398.000000 1675.500000,398.000000  "
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M755.000000,270.500000  C756.356812,272.952087 754.784180,273.015137 752.999939,273.008362  C747.166748,272.986145 741.333191,272.977661 735.500061,273.013794  C733.786255,273.024414 731.941284,272.539612 730.500000,274.000000  "
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M303.000000,225.500000  C304.356781,223.047897 302.783661,222.931030 301.000061,223.001495  C294.335754,223.264709 287.648224,222.444214 280.994019,223.460754  C280.205109,223.581253 279.180908,223.928818 278.500000,223.000000  "
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1342.000000,223.500000  C1338.325806,223.500000 1334.651489,223.500000 1330.675049,223.500000  C1330.240234,230.886658 1330.312500,237.732727 1332.000000,244.500000  "
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M764.500000,442.500000  C762.582092,443.849731 763.595581,445.855042 763.565002,447.501221  C763.419800,455.331848 763.500000,463.166656 763.500000,471.500000  C766.313782,471.500000 769.156921,471.500000 772.000000,471.500000  "
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 13,
    d: " M42.000000,301.000000  C41.679527,310.497314 42.647469,320.017212 41.500000,329.500000  "
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M771.000000,277.500000  C772.115234,284.477417 771.198792,291.503326 771.504211,298.499817  C771.584534,300.339661 771.156616,302.228180 772.000000,304.000000  "
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M302.000000,43.000000  C305.333344,43.875118 308.666656,43.567280 312.258423,43.220638  C310.864960,39.000000 311.277069,35.000000 312.244720,30.917414  C308.666656,30.281288 305.333344,30.281288 301.750000,30.918352  C301.750000,34.666668 301.750000,38.333332 301.750000,42.155365  C303.201019,41.534363 304.069214,40.735878 304.500000,39.500000  "
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M323.500000,347.000000  C323.169922,355.830261 324.164337,364.685486 323.000000,373.500000  "
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M454.500000,204.000000  C454.500000,212.833328 454.500000,221.666672 454.500000,230.500000  "
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M779.500000,308.000000  C774.114319,306.492279 768.850037,308.868286 763.400452,308.457520  C763.928711,316.828094 762.817627,325.186981 764.000000,333.500000  "
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1020.000000,212.500000  C1021.051147,209.000000 1020.296936,205.500000 1020.464600,201.750000  C1016.333313,201.750000 1012.666687,201.750000 1008.493835,201.750000  C1010.223938,205.500000 1010.338318,209.000000 1009.000000,212.500000  "
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1332.000000,394.500000  C1330.740479,400.268219 1330.340332,406.094971 1330.441895,412.001007  C1330.498047,415.263580 1331.514526,416.884460 1335.003174,416.530975  C1337.491821,416.278748 1340.043579,416.820160 1342.534058,415.958588  C1344.131348,409.034882 1341.863892,401.976929 1343.000000,395.000000  "
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1773.000000,478.500000  C1774.253906,481.609436 1772.967529,484.852600 1773.718018,488.250000  C1769.681152,488.250000 1765.840576,488.250000 1761.500000,488.250000  C1761.500000,486.844055 1761.500000,485.172028 1761.500000,483.500000  "
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M803.000000,386.000000  C803.000000,384.000000 803.000000,382.000000 803.000000,379.380371  C796.333313,379.836670 789.666687,378.893250 783.000000,380.000000  "
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10,
    d: " M727.500000,234.500000  C727.500000,243.166672 727.500000,251.833328 727.500000,260.500000  "
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M474.500000,126.500000  C474.500000,132.333328 474.797119,138.187775 474.384949,143.991837  C474.149994,147.300949 475.494751,149.054108 478.000000,150.500000  "
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    d: " M421.000000,201.000000  C416.316132,201.339523 411.555511,201.800232 406.974762,202.067795  C400.122314,202.468079 393.053986,203.336502 385.934509,201.504578  C380.599609,200.131836 374.666656,201.083328 369.000000,201.000000  "
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M496.500000,238.500000  C496.500000,247.000000 496.500000,255.500000 496.500000,264.000000  "
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M381.500000,395.000000  C379.224854,392.411896 376.050568,393.155975 373.524139,393.628998  C363.527100,395.500641 353.492126,393.930756 343.500000,394.500000  C343.500000,394.166656 343.500000,393.833344 343.500000,393.500000  "
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M351.000000,515.500000  C352.415314,521.608154 350.575348,527.892334 351.993134,534.228699  C353.155243,534.318604 354.327545,534.487122 355.500000,534.488342  C372.166656,534.505493 388.833344,534.503601 405.500000,534.487244  C406.183258,534.486572 406.997162,534.822021 407.500000,534.000000  "
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1715.500000,394.500000  C1707.070923,394.623535 1698.765015,393.516052 1690.500000,392.000000  "
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M768.500000,309.000000  C768.500000,316.500000 768.455139,324.000580 768.554504,331.499268  C768.567444,332.478821 767.481201,334.061829 769.500000,334.500000  "
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M351.000000,474.000000  C352.142822,481.979675 351.818085,490.048126 351.253113,497.982422  C350.935150,502.447968 352.474609,507.219391 350.000000,511.500000  "
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1497.500000,231.000000  C1497.500000,222.486923 1497.500000,213.973862 1497.500000,205.460785  C1498.166626,205.460785 1498.833374,205.460785 1499.500000,205.460785  C1499.500000,213.973862 1499.500000,222.486923 1499.500000,231.000000  "
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M506.500000,297.000000  C501.795197,299.197083 496.820465,297.766907 491.997955,297.822205  C490.196991,297.842865 488.724152,297.425354 487.220123,299.360748  C493.624146,301.633606 491.280518,307.026581 491.453644,311.501801  C491.653198,316.660736 491.500000,321.833344 491.467957,326.967957  C491.366638,328.866638 485.690704,325.190704 488.500000,330.000000  "
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1325.500000,224.000000  C1325.883179,223.540085 1326.266235,223.080185 1327.185059,221.977341  C1318.916504,220.724335 1311.111450,222.347565 1303.500000,221.000000  "
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M274.500000,248.750000  C271.899719,247.213409 269.299408,245.676819 266.518829,244.033707  C266.306335,242.643631 266.024628,240.800705 265.672943,238.500000  C257.340118,238.500000 249.166229,238.659302 241.000885,238.463165  C228.334503,238.158905 215.654617,238.194427 203.000015,238.195633  C181.166626,238.197723 159.339432,238.474762 137.497787,238.148315  C123.676315,237.941742 109.835785,238.249649 95.999123,238.183731  C87.017967,238.140915 77.999527,238.312714 68.999435,238.467041  C65.239243,238.531525 61.585712,237.678284 57.986034,236.544327  C56.533539,236.086777 55.258179,235.469482 55.043274,233.993698  C54.268581,228.673721 49.621223,228.179047 45.959785,227.141983  C41.413803,225.854385 39.120575,229.255341 40.500504,234.499863  C43.287022,245.090256 41.936066,255.809296 41.500000,266.500000  "
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M489.500000,302.000000  C489.500000,310.333344 489.500000,318.666656 489.500000,327.000000  "
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M765.500000,309.000000  C765.500000,316.833344 765.528320,324.666962 765.446533,332.499451  C765.439880,333.131073 766.471985,334.652649 764.500000,334.500000  "
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M544.500000,238.000000  C535.167114,238.000000 525.834167,238.000000 516.500000,238.000000  C516.500000,247.000000 516.500000,255.500000 516.500000,264.000000  "
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M439.000000,474.500000  C437.523956,486.333344 439.229309,498.166473 439.043549,510.000671  C439.035797,510.495331 439.666656,511.000000 440.000000,511.500000  "
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M347.000000,474.000000  C345.867401,481.812775 346.818634,489.670197 346.488678,497.499512  C346.418182,499.171326 346.941833,500.910858 346.000000,502.500000  "
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1669.500000,206.500000  C1670.380371,214.652100 1669.864990,222.832687 1670.000000,231.000000  "
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M440.000000,77.500000  C437.782104,83.186089 439.089478,89.185699 438.676086,95.012497  C438.017181,104.299080 438.500000,113.666664 438.500000,123.000000  "
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M350.000000,77.500000  C352.474609,81.780602 350.935181,86.552048 351.253143,91.017578  C351.818085,98.951897 352.142822,107.020340 351.000000,115.000000  "
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1670.000000,408.500000  C1669.818237,416.666351 1670.454834,424.849426 1669.500000,433.000000  "
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M55.500000,236.000000  C53.689255,237.273438 54.002937,239.187363 54.001842,241.000000  C53.997406,248.333328 54.000000,255.666672 54.000000,263.000000  "
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M793.000000,443.500000  C794.024475,440.500000 793.227356,437.500000 793.597412,434.335815  C786.128662,435.891907 779.364380,433.318695 772.496765,433.965393  C768.681580,434.324646 764.832947,434.457031 761.000183,434.445923  C759.183411,434.440674 759.471191,435.436737 759.520752,436.741394  C766.564331,436.491394 773.692322,435.814056 780.500000,438.500000  "
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M143.500000,229.000000  C150.474594,227.766479 157.507217,228.969910 165.000000,228.354828  C165.000000,239.995178 165.000000,251.497589 165.000000,263.000000  "
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M443.000000,474.500000  C444.123810,482.145874 443.178009,489.837006 443.511078,497.499512  C443.583740,499.171326 443.058167,500.910858 444.000000,502.500000  "
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M444.000000,85.500000  C442.852417,93.479561 443.832184,101.503578 443.495453,109.499809  C443.417969,111.339745 443.843353,113.228188 443.000000,115.000000  "
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1324.500000,312.500000  C1317.501831,312.253998 1310.479492,313.041138 1303.499634,312.002502  C1302.339355,311.829834 1301.361084,312.249969 1300.500000,313.000000  "
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M346.000000,85.500000  C347.147583,93.479561 346.167786,101.503578 346.504547,109.499809  C346.582031,111.339745 346.156647,113.228188 347.000000,115.000000  "
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1602.000000,483.000000  C1601.089233,481.062012 1601.679443,478.998932 1601.447998,476.750000  C1597.681152,476.750000 1593.840576,476.750000 1589.500000,476.750000  C1589.500000,480.319000 1589.500000,484.159485 1589.500000,488.250000  C1593.318848,488.250000 1597.159424,488.250000 1601.206787,488.250000  C1601.440308,486.851379 1601.720093,485.175690 1601.999878,483.500000  "
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M368.500000,393.000000  C360.500000,392.167328 352.500000,392.167328 344.500000,393.000000  "
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M362.000000,406.500000  C358.774170,412.828430 352.885010,411.357422 347.500885,411.527557  C343.500610,411.653900 339.465057,410.994476 335.500000,412.000000  "
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1496.500000,246.000000  C1494.509155,248.098129 1492.182983,248.333405 1489.491333,247.528976  C1485.395752,246.304977 1481.165649,247.168549 1476.998901,247.033875  C1472.668091,246.893860 1468.613403,246.219513 1464.410767,244.756302  C1460.843262,243.514221 1456.500000,244.500000 1452.500000,244.500000  "
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M474.000000,149.000000  C472.192291,149.724335 471.374084,150.906906 471.450043,153.001816  C471.612946,157.495911 471.503754,162.000000 471.498169,166.500000  C471.495911,168.312653 471.810760,170.226562 470.000000,171.500000  "
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1408.000000,483.000000  C1407.089233,481.062012 1407.679443,478.998932 1407.447998,476.750000  C1404.015869,476.750000 1400.507935,476.750000 1396.500000,476.750000  C1396.500000,480.318848 1396.500000,484.159424 1396.500000,488.250000  C1399.984131,488.250000 1403.492065,488.250000 1407.207031,488.250000  C1407.440552,486.851410 1407.720337,485.175720 1408.000122,483.500031  "
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M771.500000,309.000000  C771.207703,316.830658 772.110779,324.686768 771.000000,332.500000  "
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M448.000000,185.500000  C447.075562,186.984482 445.841736,187.590134 443.998901,187.546600  C438.501953,187.416763 432.985107,187.739136 427.506348,187.398117  C424.807861,187.230148 422.788971,188.149384 421.605835,190.065353  C420.355591,192.090057 420.487793,194.836151 417.005676,195.080917  C413.064087,195.357971 409.158783,196.340790 405.303467,194.221100  C406.495575,189.717514 409.533356,187.613358 413.500000,186.500000  "
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1703.000000,240.500000  C1695.333374,240.500000 1687.666626,240.500000 1680.000000,240.500000  "
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M315.000000,125.500000  C315.000000,131.833328 314.969421,138.166916 315.018829,144.499847  C315.033539,146.379486 315.077179,147.866425 316.762329,149.716492  C318.769623,151.920319 317.323883,155.834061 317.517639,158.998917  C317.569061,159.839096 317.071198,160.819092 318.000000,161.500000  "
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M709.500000,406.000000  C704.963684,403.842010 700.149292,405.560089 695.501038,404.991608  C692.504211,404.625092 689.315674,405.992462 686.500000,404.000000  "
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M314.000000,440.500000  C316.116486,448.089142 314.489319,455.841034 315.000000,463.500000  "
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1465.500000,240.500000  C1473.000000,240.500000 1480.500000,240.500000 1488.000000,240.500000  "
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    d: " M1053.000000,389.000000  C1045.469116,389.319397 1037.781738,387.877716 1030.500000,391.000000  "
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    d: " M36.000000,220.000000  C37.585739,220.737976 39.222008,221.046921 41.000278,221.030930  C46.873230,220.978104 52.787468,220.590637 58.500000,222.500000  "
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1677.000000,401.500000  C1682.618042,403.320312 1688.334473,401.589691 1694.003418,401.946014  C1699.189087,402.271912 1699.838623,402.708374 1700.000000,408.000000  "
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1704.000000,243.500000  C1699.291260,241.360474 1694.329834,242.890564 1689.496948,242.542725  C1686.346558,242.315979 1683.166626,242.500000 1680.000000,242.500000  "
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M783.500000,444.000000  C781.746399,442.956451 779.822449,443.786438 777.471741,443.346130  C777.798462,455.666656 776.862183,467.833344 778.000000,480.000000  "
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M297.500000,405.000000  C291.860901,403.895782 286.160461,404.830719 280.501587,404.474579  C278.834900,404.369659 277.077454,405.058685 275.500000,404.000000  "
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M904.000000,311.500000  C903.167114,318.833344 903.167114,326.166656 904.000000,333.500000  "
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M906.000000,311.500000  C906.832886,318.833344 906.832886,326.166656 906.000000,333.500000  "
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1466.500000,213.500000  C1459.910278,211.627548 1453.164795,212.867752 1446.500488,212.491531  C1442.169312,212.247009 1437.796143,213.134140 1433.500000,212.000000  "
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1028.000000,311.500000  C1027.167114,318.833344 1027.167114,326.166656 1028.000000,333.500000  "
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1030.000000,311.500000  C1030.832886,318.833344 1030.832886,326.166656 1030.000000,333.500000  "
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    d: " M421.000000,388.000000  C415.517029,388.687256 409.783844,386.474365 404.472565,389.451080  C403.995636,389.718353 403.167511,389.632477 402.474060,389.029846  C396.727051,384.035797 389.696472,386.013794 383.550598,386.865265  C378.671844,387.541107 373.853790,387.697754 369.000000,388.000000  "
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1090.000000,315.500000  C1089.167114,322.833344 1089.167114,330.166656 1090.000000,337.500000  "
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1499.500000,205.500000  C1503.171753,204.068588 1503.586304,201.511627 1500.877075,196.000000  C1498.668701,196.000000 1496.189575,195.506470 1494.040161,196.137085  C1491.835571,196.783920 1489.717773,196.998505 1487.585571,196.995819  C1485.411865,197.970612 1487.389282,200.296417 1486.000000,201.500000  "
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1194.000000,315.500000  C1193.167114,322.833344 1193.167114,330.166656 1194.000000,337.500000  "
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M342.000000,185.500000  C343.736206,187.565659 346.126648,187.501862 348.500000,187.500687  C353.166656,187.498367 357.853516,187.760208 362.492310,187.400650  C365.196533,187.191025 367.856750,188.142593 368.309357,190.045349  C369.754974,196.122940 374.166626,195.514221 378.499908,195.486740  C380.420807,195.474564 382.340759,195.318375 384.559631,195.213455  C384.166046,189.887802 380.786255,187.780670 376.500000,186.500000  "
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1093.000000,315.500000  C1093.832886,322.833344 1093.832886,330.166656 1093.000000,337.500000  "
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1197.000000,315.500000  C1197.832886,322.833344 1197.832886,330.166656 1197.000000,337.500000  "
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1463.000000,426.500000  C1455.833374,426.500000 1448.666626,426.500000 1441.500000,426.500000  C1441.500000,428.166656 1441.500000,429.833344 1441.500000,431.500000  "
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M902.000000,207.000000  C902.890564,205.444778 903.288208,203.790985 902.821472,201.750000  C899.333313,201.750000 895.666687,201.750000 891.790344,201.750000  C891.461365,205.500000 890.970886,209.000000 892.000000,212.500000  "
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10,
    d: " M512.500000,234.500000  C509.566345,235.278610 509.475800,237.573395 509.487976,240.000061  C509.522308,246.833221 509.500000,253.666672 509.500000,260.500000  "
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M496.500000,301.500000  C496.500000,310.000000 496.500000,318.500000 496.500000,327.000000  "
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M474.000000,440.250000  C475.034576,444.129730 474.325562,448.084137 474.472443,452.001038  C474.603485,455.496124 474.500000,459.000000 474.500000,462.500000  "
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M267.000000,340.500000  C264.973907,344.842651 267.369019,352.826447 271.499969,355.500031  C277.331451,359.274231 277.571442,366.713440 272.000000,371.000000  "
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1465.000000,243.500000  C1470.052612,241.399231 1475.338501,242.926392 1480.502441,242.532700  C1482.988037,242.343185 1485.500000,242.500000 1488.000000,242.500000  "
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1191.500000,420.500000  C1191.500000,422.000763 1191.500000,423.501526 1191.500000,425.250000  C1195.666626,425.250000 1199.333374,425.250000 1203.161133,425.250000  C1203.706177,421.333344 1203.706177,417.666656 1203.161133,413.750000  C1199.333374,413.750000 1195.666626,413.750000 1191.500000,413.750000  C1191.500000,415.498474 1191.500000,416.999237 1191.500000,418.500000  "
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M356.000000,459.000000  C354.122131,459.988495 352.259674,460.665497 349.997192,460.560089  C343.670746,460.265320 337.314331,460.888763 331.022461,459.891846  C330.665710,461.499786 330.332855,462.999908 330.000000,464.500000  "
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1502.000000,434.500000  C1502.932373,435.914917 1502.373413,437.496979 1502.490601,439.000732  C1502.713379,441.855225 1501.358521,443.164917 1498.499634,443.006470  C1495.001099,442.812531 1491.500000,442.666656 1488.000000,442.499969  "
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M668.500000,413.500000  C667.166687,413.404327 666.026550,414.267944 664.465149,413.579010  C658.948730,411.145081 653.187012,412.474182 647.500000,413.000000  "
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1462.500000,232.500000  C1455.500000,232.500000 1448.500000,232.500000 1441.500000,232.500000  C1441.500000,237.666672 1441.500000,242.833328 1441.500000,248.000000  "
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1487.500000,175.500000  C1487.794922,182.496948 1486.884766,189.522583 1488.000000,196.500000  "
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M336.500000,177.000000  C342.305511,178.140594 348.170929,177.404694 354.000031,177.406967  C356.989044,177.408127 358.913971,178.266541 360.000000,181.000000  "
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1464.500000,401.000000  C1464.148926,398.229309 1465.399658,397.802094 1468.003784,397.910797  C1474.492432,398.181641 1481.000000,398.000000 1487.500000,398.000000  "
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M453.500000,177.000000  C447.694489,178.140594 441.829071,177.404709 435.999969,177.406967  C433.010956,177.408127 431.086029,178.266541 430.000000,181.000000  "
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10,
    d: " M614.000000,232.500000  C618.131836,237.246124 617.190735,243.439423 616.610840,248.455017  C615.771484,255.715759 618.320068,260.527832 623.077881,264.915527  C623.812317,265.592804 624.118286,266.244598 624.500000,267.000000  "
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1486.000000,438.500000  C1489.032715,446.681366 1486.845337,455.175934 1487.500000,463.500000  "
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1442.500000,416.500000  C1449.500000,416.500000 1456.500000,416.500000 1463.250000,416.500000  C1463.250000,411.500000 1463.250000,406.500000 1463.250000,401.093079  C1465.565674,401.984833 1467.532837,402.742401 1469.500000,403.499969  "
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1499.500000,411.500000  C1497.561646,413.041534 1498.614014,415.171509 1498.556641,417.001770  C1498.394653,422.163361 1498.500000,427.333344 1498.500000,432.500000  "
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1442.000000,217.500000  C1448.833374,217.500000 1455.666626,217.500000 1462.500000,217.500000  "
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M630.500000,413.500000  C630.213379,420.330414 631.050415,427.182983 630.060120,434.008728  C629.948608,434.777527 630.666687,435.666656 631.000000,436.500000  "
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M418.500000,63.500000  C421.189697,62.987804 419.984375,60.826946 419.924042,59.503464  C419.634827,53.159134 418.427856,46.878502 419.197632,40.500000  C415.833344,40.500000 413.166656,40.500000 410.500000,40.500000  "
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M75.500000,417.000000  C76.502106,418.516022 77.138794,420.141693 76.980072,422.250000  C73.333336,422.250000 69.666664,422.250000 65.500000,422.250000  C65.500000,420.501526 65.500000,419.000763 65.500000,417.500000  "
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M687.500000,535.000000  C691.506958,535.000000 695.513916,535.000000 699.750000,535.000000  C699.750000,529.166687 699.750000,523.833313 699.750000,518.000000  C695.513916,518.000000 691.506958,518.000000 687.500000,518.000000  "
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1442.000000,215.500000  C1448.833374,215.500000 1455.666626,215.500000 1462.500000,215.500000  "
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1462.500000,406.500000  C1452.836060,406.173859 1443.149414,407.169037 1433.500000,406.000000  "
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M76.000000,416.000000  C76.921043,414.450867 77.231781,412.779694 76.850136,410.750000  C73.333336,410.750000 69.666664,410.750000 65.500000,410.750000  C65.500000,412.498474 65.500000,413.999237 65.500000,415.500000  "
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M330.500000,494.500000  C331.957672,494.613770 333.051727,494.407776 333.021576,492.499664  C332.953125,488.167389 332.953125,483.832611 333.021576,479.500336  C333.051727,477.592224 331.957672,477.386230 330.500000,477.500000  "
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M274.000000,231.500000  C268.316559,228.600693 262.166260,228.244568 256.002197,228.545059  C245.835556,229.040726 235.644974,228.828583 225.501007,228.781860  C205.503143,228.689758 185.500473,228.610077 165.500000,228.500000  "
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M481.500000,465.500000  C482.069031,473.990753 482.904633,482.470154 482.507843,491.000366  C482.416809,492.957306 482.918701,495.053589 481.000000,496.500000  "
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    d: " M361.500000,182.500000  C358.386292,183.336426 355.223022,183.701462 352.000000,183.500046  C344.932739,183.058395 338.131592,185.926041 330.993561,185.052643  C326.032593,184.445633 321.107666,183.812042 315.982635,184.327103  C311.230774,184.804642 306.333344,183.833344 301.500000,183.500000  "
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M490.500000,374.500000  C490.500000,378.673340 490.500000,382.846649 490.500000,386.941193  C486.097412,388.502289 482.015961,387.858063 478.000000,388.000000  "
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    d: " M464.500000,187.500000  C464.289551,186.492950 465.115875,184.900162 462.999512,184.987976  C461.502075,185.050095 459.999847,184.985901 458.500031,185.002289  C448.420990,185.112289 438.497620,183.361816 428.500000,182.500000  "
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M469.000000,494.500000  C467.001038,489.561066 465.625977,485.012817 468.194794,479.361267  C469.827209,475.769928 468.668671,470.822754 468.397797,466.506409  C468.315887,465.201508 468.784943,464.680634 470.025238,463.551056  C471.536804,474.762390 469.518982,485.711945 471.000000,496.500000  "
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M330.500000,110.500000  C331.458832,110.480408 332.887695,110.717018 332.933258,109.497505  C333.101257,105.003784 333.052460,100.499054 332.971100,96.000526  C332.943207,94.458061 331.681976,94.418945 330.500000,94.500000  "
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1675.000000,212.500000  C1672.751587,218.732544 1674.604736,225.180954 1674.000000,231.500000  "
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M558.500000,413.500000  C557.166687,413.404327 556.022522,414.297272 554.464844,413.575928  C549.623108,411.333710 544.528870,412.300690 539.500000,413.000000  "
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M459.500000,477.500000  C457.718384,477.441376 457.617004,479.064941 457.576935,480.003296  C457.399292,484.162354 457.579163,488.335602 457.460358,492.498871  C457.413879,494.127655 458.548004,494.118652 459.500000,494.500000  "
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M665.000000,502.000000  C665.000000,504.666656 664.997620,507.333344 665.000549,510.000000  C665.007080,516.000000 665.008118,516.000000 671.000000,516.000000  "
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M1682.000000,438.500000  C1681.530151,440.653503 1681.223267,442.928040 1677.987427,442.046112  C1677.409180,441.888489 1676.675537,442.401031 1675.998657,442.489838  C1666.165039,443.779785 1665.441284,443.423157 1667.004761,433.971375  C1670.405518,432.669464 1674.804077,434.814178 1677.500000,431.000000  "
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M542.500000,229.000000  C541.082458,230.289536 540.162842,231.556030 537.472412,231.222855  C533.248779,230.699844 528.794067,231.211517 524.500610,231.202469  C521.598083,231.196365 522.729492,232.396179 522.500000,233.500000  "
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    d: " M471.500000,90.500000  C471.609222,93.356316 471.128510,95.874367 474.320221,98.242302  C477.195526,100.375504 476.738068,104.468674 474.000000,107.500000  "
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M302.500000,267.500000  C295.666962,267.321228 288.820587,267.956512 281.995117,267.036285  C279.964813,266.762573 277.860748,266.831085 276.000000,268.000000  "
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M302.500000,373.500000  C295.666962,373.321228 288.820587,373.956482 281.995117,373.036255  C279.964813,372.762543 277.860748,372.831085 276.000000,374.000000  "
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1491.500000,404.000000  C1489.235107,400.917480 1485.818115,402.658905 1482.978271,402.113434  C1480.245605,401.588623 1477.332397,401.951935 1474.500244,402.010895  C1469.880249,402.107025 1469.201416,402.877655 1469.000000,408.000000  "
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1674.500000,408.000000  C1674.033203,414.183777 1673.060059,420.381256 1675.000000,426.500000  "
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M302.500000,355.500000  C295.666962,355.321228 288.820587,355.956482 281.995117,355.036285  C279.964813,354.762573 277.860748,354.831085 276.000000,356.000000  "
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M302.500000,330.500000  C295.666962,330.321228 288.820587,330.956482 281.995117,330.036285  C279.964813,329.762573 277.860748,329.831085 276.000000,331.000000  "
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M359.500000,411.000000  C361.916626,412.417358 364.490143,410.757812 367.020203,411.423187  C369.086792,411.966675 370.065155,409.476044 369.824097,408.545563  C369.283600,406.459259 367.495331,405.430634 364.999786,405.438751  C358.833740,405.458832 352.667175,405.138245 346.499542,405.025238  C345.339996,405.003967 344.361115,404.750031 343.500000,404.000000  "
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1633.000000,446.000000  C1635.236084,442.041656 1635.565918,437.854584 1634.566406,433.514008  C1632.559937,432.614624 1630.501343,433.150085 1628.500000,433.000000  "
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M904.000000,271.500000  C903.169617,277.500000 903.169617,283.500000 904.000000,289.500000  "
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 13,
    d: " M42.000000,267.500000  C42.000000,277.666656 42.000000,287.833344 42.000000,298.000000  "
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M439.000000,74.500000  C437.823517,68.025894 438.968201,61.492268 438.343597,54.406178  C432.500000,54.843498 426.500000,53.899826 420.500000,55.000000  "
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M439.000000,515.500000  C437.872528,521.500000 438.908173,527.500000 438.352936,534.000000  C432.701752,534.000000 426.350891,534.000000 419.999847,534.000000  C418.472931,538.885864 420.897583,543.710815 418.500000,548.000000  "
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1697.500000,237.000000  C1691.666626,238.259735 1685.833374,237.159180 1680.000000,237.000000  "
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M339.500000,412.500000  C339.500000,417.000000 339.500000,421.500000 339.500000,426.044678  C338.272400,427.012451 336.823395,426.253754 335.500000,426.500000  "
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M450.500000,412.500000  C450.500000,417.000000 450.500000,421.500000 450.500000,426.044678  C451.727600,427.012451 453.176605,426.253754 454.500000,426.500000  "
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M906.000000,271.500000  C907.375244,277.105377 905.650146,282.893127 907.000000,288.500000  "
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M490.500000,268.500000  C490.500000,278.000000 490.500000,287.500000 490.500000,297.000000  "
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M611.500000,398.500000  C611.500000,401.500000 611.500000,404.500000 611.500000,407.734863  C623.801331,410.036530 636.148254,409.195984 648.500000,408.000000  "
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M463.500000,170.499985  C465.516052,171.204941 467.532104,171.909897 469.538147,172.611343  C469.483643,176.362823 467.683746,179.809723 468.500000,183.500000  "
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M672.000000,500.500000  C673.111633,490.348816 672.302734,480.165894 672.446228,469.999237  C672.519043,464.839874 672.030640,459.672607 671.793945,454.464417  C675.763367,452.724518 679.653748,453.870178 684.078369,453.307068  C683.568176,458.004089 682.884155,462.039551 684.498718,466.495697  C680.333313,466.314545 676.666687,467.014740 673.000000,466.000000  "
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M576.500000,413.000000  C570.833313,412.187439 565.166687,412.187439 559.500000,413.000000  "
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M635.000000,414.500000  C633.395386,420.166656 633.395386,425.833344 635.000000,431.500000  "
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1702.500000,439.000000  C1704.842285,438.492798 1704.504883,440.117340 1704.502930,441.500000  C1704.495972,446.500000 1704.500000,451.500000 1704.500000,456.500000  "
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1488.000000,237.000000  C1482.500000,237.470062 1477.000000,238.048645 1471.500000,237.000000  "
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M514.500000,268.500000  C509.166656,268.500000 503.833344,268.500000 498.500000,268.500000  "
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1324.500000,272.500000  C1317.665649,272.373993 1310.816895,272.968567 1303.996582,272.025024  C1302.760376,271.854004 1301.416748,271.792114 1300.500000,273.000000  "
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10,
    d: " M619.500000,336.000000  C617.572754,339.059875 614.844604,341.795044 616.887878,346.053802  C617.443726,347.212433 617.800781,347.832520 618.908020,348.628021  C621.177307,350.258545 623.237915,352.349976 624.500000,355.000000  "
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M771.500000,340.000000  C771.500000,345.333344 771.500000,350.666656 771.500000,356.000000  "
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M1052.500000,307.000000  C1047.187744,306.157684 1041.834595,306.626312 1036.500000,306.500000  "
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M514.500000,374.500000  C509.166656,374.500000 503.833344,374.500000 498.500000,374.500000  "
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M322.000000,384.500000  C322.000000,381.833344 322.083893,379.163391 321.980377,376.500763  C321.824005,372.479156 321.110870,372.202789 316.978271,373.426636  C315.446014,373.880432 313.666656,373.500000 312.000000,373.500000  "
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M470.500000,438.500000  C470.200562,443.829193 471.101807,449.195892 470.000000,454.500000  "
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M553.000000,468.500000  C553.000000,465.166656 552.964172,461.832825 553.013000,458.500183  C553.043884,456.389282 552.704895,454.862885 549.998413,454.951904  C547.799561,455.024200 545.991638,455.207336 545.999512,458.000000  C546.039246,472.166656 544.647034,486.333344 546.000000,500.500000  "
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1324.500000,224.500000  C1317.665649,224.373978 1310.816895,224.968536 1303.996582,224.025040  C1302.760376,223.854034 1301.416748,223.792114 1300.500000,225.000000  "
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M473.500000,110.000000  C473.815094,115.161880 472.839935,120.365379 474.000000,125.500000  "
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1771.500000,476.500000  C1768.333374,476.500000 1765.166626,476.500000 1761.500000,476.500000  C1761.500000,478.486237 1761.500000,480.493134 1761.500000,482.500000  "
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M756.500000,226.000000  C759.719604,221.622559 754.160278,223.200012 753.997803,223.198212  C747.833740,223.130432 741.667297,223.385117 735.499512,223.458603  C734.182251,223.474304 732.721924,224.058014 731.500000,223.000000  "
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M756.500000,330.000000  C759.719604,325.622559 754.160278,327.200043 753.997803,327.198242  C747.833740,327.130493 741.667297,327.385132 735.499512,327.458588  C734.182251,327.474304 732.721924,328.058014 731.500000,327.000000  "
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1343.000000,221.500000  C1342.833374,229.166672 1342.666626,236.833328 1342.500000,244.500000  "
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M769.000000,340.000000  C767.928528,344.634338 768.742493,349.335724 768.512329,354.000610  C768.429993,355.669250 769.334656,356.601379 770.998413,356.478607  C773.830444,356.269592 776.722534,357.116577 779.500000,356.000000  "
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M508.500000,281.500000  C504.500000,281.500000 500.500000,281.500000 496.500000,281.500000  C496.500000,286.833344 496.500000,292.166656 496.500000,297.500000  "
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M1468.500000,215.500000  C1471.648315,218.347092 1472.901489,222.529358 1475.901733,225.596085  C1479.427612,229.199997 1483.014648,231.059586 1488.013794,229.545700  C1488.578247,229.374786 1489.333374,229.833328 1490.000000,230.000000  "
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M457.000000,393.500000  C460.492096,391.357025 462.406097,392.863586 464.612000,395.919128  C467.892212,400.462769 468.717804,404.921265 466.500000,410.000000  "
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1325.500000,272.000000  C1328.719604,267.622559 1323.161743,269.200470 1322.997559,269.198517  C1317.167114,269.127991 1311.333984,269.388062 1305.499512,269.458252  C1304.182251,269.474060 1302.721924,270.058014 1301.500000,269.000000  "
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10,
    d: " M1639.000000,451.250000  C1633.413086,454.380127 1629.882446,462.213623 1631.000000,469.000000  "
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M764.500000,340.500000  C764.500000,345.500000 764.500000,350.500000 764.500000,355.500000  "
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M421.000000,399.500000  C420.666656,402.333344 420.043060,405.173279 420.107666,407.997528  C420.147064,409.721710 420.961731,412.199280 423.465515,411.392914  C425.879272,410.615479 428.275116,412.684967 430.500000,411.000000  "
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M684.500000,413.000000  C679.500000,412.168640 674.500000,412.168640 669.500000,413.000000  "
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1324.500000,394.500000  C1317.665649,394.373993 1310.818726,394.953094 1303.992310,394.058929  C1303.215942,393.957214 1302.333374,394.666687 1301.500000,395.000031  "
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M697.500000,399.000000  C696.219055,400.319183 694.540161,400.160187 693.005188,399.960236  C689.459900,399.498352 686.453979,400.361877 684.000000,403.000000  "
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M638.000000,415.500000  C638.831360,420.500000 638.831360,425.500000 638.000000,430.500000  "
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M470.000000,134.500000  C471.491272,139.422806 469.508728,144.577194 471.000000,149.500000  "
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10,
    d: " M1558.000000,451.250000  C1563.586914,454.380127 1567.117554,462.213654 1566.000000,469.000000  "
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M165.000000,268.500000  C165.000000,277.833344 165.000000,287.166656 165.000000,296.500000  "
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M330.000000,64.000000  C336.722626,66.012878 343.633057,65.459526 350.500000,65.500000  "
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M439.500000,65.500000  C446.500000,65.333336 453.500000,65.166664 460.500000,65.000000  "
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M474.000000,61.500000  C476.466064,59.561882 479.358307,61.033031 483.000000,60.053459  C483.000000,68.822662 483.022858,77.161514 482.956726,85.499657  C482.951447,86.168922 482.333344,86.833328 482.000000,87.500000  "
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M331.000031,116.000008  C330.571930,118.180771 330.143860,120.361534 329.625916,123.000000  C326.853882,123.000000 324.176941,123.000000 321.500000,123.000000  "
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M54.000000,268.500000  C54.000000,277.833344 54.000000,287.166656 54.000000,296.500000  "
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M330.000000,526.500000  C336.782104,525.116394 343.653076,525.554871 350.500000,525.500000  "
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M439.500000,525.500000  C446.346924,525.554871 453.217896,525.116394 460.000000,526.500000  "
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M481.000000,89.000000  C474.210083,90.223076 467.347046,90.082970 460.500427,89.973846  C452.202545,89.841599 450.554993,91.969421 453.000000,101.500000  "
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M165.000000,302.000000  C165.000000,310.000000 165.000000,318.000000 165.000000,326.000000  "
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1494.000000,213.500000  C1494.815796,218.166672 1494.815796,222.833328 1494.000000,227.500000  "
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M54.000000,302.000000  C54.000000,310.000000 54.000000,318.000000 54.000000,326.000000  "
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1426.500000,289.500000  C1431.166626,289.500000 1435.833374,289.500000 1440.500000,289.500000  "
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1382.000000,302.000000  C1377.274048,305.209534 1372.304932,308.106293 1368.500000,312.500000  "
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M266.000000,356.000000  C265.097290,360.976685 266.281372,365.580719 268.500000,370.000000  "
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1466.000000,393.000000  C1463.748657,395.715088 1460.687988,394.158478 1457.995605,394.461243  C1456.185181,394.664856 1454.333374,394.500000 1452.500000,394.500000  "
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    d: " M1689.000000,391.000000  C1684.345093,391.302887 1679.258789,389.664764 1675.500000,394.000000  "
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M588.500000,485.500000  C582.610901,485.111877 577.176147,482.792999 571.500000,481.500000  "
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M391.500000,387.500000  C391.666656,391.666656 391.716095,395.842712 392.047577,399.996216  C392.223450,402.200287 393.756134,403.912750 395.979706,403.410217  C400.504761,402.387573 405.049225,404.495972 409.500000,403.000000  "
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M479.500000,111.500000  C479.500000,116.000000 479.500000,120.500000 479.500000,125.000000  "
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1494.500000,412.000000  C1494.170776,416.493988 1495.161255,421.036835 1494.000000,425.500000  "
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1365.500000,312.500000  C1366.333374,312.500000 1367.425171,312.154053 1367.959839,312.553680  C1373.193115,316.464630 1378.333374,320.499969 1383.500000,324.499969  "
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M780.000000,320.000000  C779.231323,324.500000 779.128235,329.000000 780.000000,333.500000  "
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1498.500000,451.000000  C1498.500000,455.500000 1498.500000,460.000000 1498.500000,464.500000  "
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M770.500000,439.500000  C771.672363,439.590729 772.844727,439.681427 773.404358,439.724731  C771.888977,451.281036 772.347351,462.637665 773.000000,474.000000  "
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M625.000000,310.500000  C628.785828,314.846008 629.461914,320.021271 629.000000,325.500000  "
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M483.000000,372.500000  C479.684448,370.992950 479.474426,373.068054 479.492126,375.500061  C479.521240,379.499847 479.500000,383.500000 479.500000,387.500000  "
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1486.500000,210.500000  C1484.785278,215.705505 1486.567139,219.599838 1491.000000,222.500000  "
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M490.500000,356.500000  C490.500000,360.833344 490.500000,365.166656 490.500000,369.500000  "
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1498.500000,175.500000  C1498.500000,179.833328 1498.500000,184.166672 1498.500000,188.500000  "
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M319.500000,163.500000  C319.614777,167.872070 318.400635,172.848190 324.500000,174.500000  "
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M334.500000,165.500000  C334.500000,166.000000 334.516754,166.500641 334.497467,166.999908  C334.264313,173.038300 333.210419,173.940369 327.500000,173.000000  "
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1295.500000,401.500000  C1296.500000,401.833344 1297.610352,402.617554 1298.476929,402.405579  C1300.252808,401.971191 1302.525269,401.744965 1302.506348,398.999969  C1302.487671,396.298035 1300.998901,395.344147 1298.499634,395.493958  C1297.835449,395.533783 1297.166626,395.500000 1296.500000,395.500000  "
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M671.500000,455.000000  C664.038757,454.680664 664.993164,455.629883 664.999573,461.500000  C665.002075,463.833344 665.000000,466.166656 665.000000,468.500000  "
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M471.000000,367.500000  C470.833344,373.500000 470.666687,379.500000 470.500000,385.500000  "
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1582.500000,289.500000  C1586.833374,289.500000 1591.166626,289.500000 1595.500000,289.500000  "
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1564.000000,193.000000  C1562.338989,195.957336 1561.538696,199.123871 1562.022095,202.496841  C1562.515137,205.937042 1560.302612,209.063583 1561.000000,212.500000  "
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1633.000000,193.000000  C1634.661011,195.957336 1635.461426,199.123886 1634.978027,202.496857  C1634.484985,205.937073 1636.697388,209.063583 1636.000000,212.500000  "
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M610.500000,408.000000  C606.197693,408.973969 601.837158,408.432983 597.500000,408.500000  "
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M265.500000,267.500000  C267.171234,272.311462 266.131989,278.396851 272.940948,280.676361  C275.674194,281.591370 275.097260,285.299133 275.585114,287.984528  C276.396149,292.448944 275.952698,296.441528 273.000000,300.000000  "
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1427.000000,216.500000  C1431.333374,216.500000 1435.666626,216.500000 1440.000000,216.500000  "
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M623.500000,268.500000  C619.166687,268.500000 614.833313,268.500000 610.500000,268.500000  "
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M452.500000,76.500000  C450.217957,80.683434 452.253693,85.199005 451.335876,89.500000  C450.333344,89.500000 449.166656,89.500000 447.883606,89.500000  C446.741333,87.298859 448.302277,84.694908 447.000000,82.500000  "
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M337.500000,76.500000  C339.912170,77.955360 338.163300,80.182205 338.416046,82.011597  C338.754974,84.464775 338.500000,87.000000 338.500000,89.500000  C339.666656,89.500000 340.833344,89.500000 342.116394,89.500000  C343.258667,87.298859 341.697723,84.694908 343.000000,82.500000  "
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M54.000000,356.500000  C54.000000,360.666656 54.000000,364.833344 54.000000,369.000000  "
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M774.000000,475.500000  C775.645142,478.382385 774.951294,479.508942 771.500916,479.560394  C763.778687,479.675446 756.166382,478.504272 748.500000,478.000000  "
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12,
    d: " M1565.500000,393.500000  C1565.500000,402.833344 1565.500000,412.166656 1565.500000,421.500000  "
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12,
    d: " M1631.500000,393.500000  C1631.500000,402.833344 1631.500000,412.166656 1631.500000,421.500000  "
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M453.000000,103.500000  C451.150299,108.372795 451.352478,112.941612 455.000000,117.000000  "
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M468.500000,115.000000  C464.333405,115.334206 460.045105,114.147301 456.000000,116.000000  "
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M335.000000,461.000000  C333.898163,465.129272 334.785065,469.338074 334.500000,473.500000  "
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M165.000000,356.500000  C165.000000,360.666656 165.000000,364.833344 165.000000,369.000000  "
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1708.000000,410.500000  C1708.806152,414.500000 1708.806152,418.500000 1708.000000,422.500000  "
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M771.500000,360.000000  C771.500000,364.000000 771.500000,368.000000 771.500000,372.000000  "
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M54.500000,398.500000  C54.500000,402.500000 54.500000,406.500000 54.500000,410.500000  "
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    d: " M488.500000,183.500000  C482.162476,183.507431 475.882690,185.365738 469.494995,184.023834  C467.640594,183.634262 466.081635,184.716568 464.500000,185.500000  "
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M165.000000,374.500000  C165.000000,378.500000 165.000000,382.500000 165.000000,386.500000  "
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M54.000000,374.500000  C54.000000,378.500000 54.000000,382.500000 54.000000,386.500000  "
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M482.000000,83.500000  C478.000000,83.500000 474.000000,83.500000 470.000000,83.500000  "
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1312.500000,341.000000  C1308.515747,340.477966 1304.350220,342.131256 1300.500000,340.000000  "
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M627.000000,231.500000  C629.046814,236.660812 630.252686,241.926743 629.000000,247.500000  "
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M464.500000,514.500000  C464.562012,520.026733 460.681305,524.506653 460.387238,529.993958  C460.322998,531.193237 458.478485,530.204285 457.500000,530.500000  "
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M325.500000,514.500000  C326.453247,518.398315 326.338623,522.623169 329.001556,525.998779  C330.107605,527.400879 329.227936,529.011719 329.500000,530.500000  "
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M334.500000,116.000000  C334.776917,119.995407 333.913483,124.038330 335.000000,128.000000  "
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M495.500000,237.000000  C499.735779,239.877914 504.506561,237.940857 509.000000,238.500000  "
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9,
    d: " M728.000000,305.500000  C728.000000,311.666656 728.000000,317.833344 728.000000,324.000000  "
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9,
    d: " M494.500000,305.000000  C499.166656,305.000000 503.833344,305.000000 509.000000,305.000000  C509.000000,311.324554 509.000000,317.662292 509.000000,324.000000  "
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M484.000000,409.500000  C485.049225,411.426453 484.262665,413.506042 484.500824,415.499908  C484.938171,419.161407 481.153717,417.388123 480.000000,419.000000  "
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1678.500000,208.750000  C1683.078369,211.605621 1683.829102,215.658615 1680.502808,219.502457  C1679.651123,220.486526 1678.833374,221.500031 1678.000000,222.500031  "
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M317.500000,374.000000  C317.500000,377.833344 317.500000,381.666656 317.500000,385.500000  "
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M322.000000,77.500000  C320.363800,79.282860 321.104675,81.475899 321.031250,83.501137  C320.962219,85.403717 321.076965,87.301872 320.000000,89.000000  "
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M473.500000,374.000000  C473.500000,377.833344 473.500000,381.666656 473.500000,385.500000  "
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1081.500000,364.000000  C1081.500000,367.833344 1081.500000,371.666656 1081.500000,375.500000  "
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M768.500000,360.000000  C768.500000,361.000000 768.500000,362.000000 768.500000,363.000000  C768.500000,373.487946 768.500000,373.487946 779.500000,372.000000  "
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1489.000000,410.000000  C1483.242065,406.922211 1481.511963,407.306671 1480.000000,412.000000  "
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M542.000000,232.000000  C542.249817,233.895950 544.923645,233.758652 545.094116,235.992828  C545.249756,238.034042 547.401550,238.463974 548.999329,238.444122  C567.499023,238.214310 586.008911,239.156067 604.500000,238.000000  "
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M318.000000,419.500000  C316.730194,424.798859 317.818390,430.167633 317.580872,435.503601  C317.349579,440.698151 317.018494,441.050659 312.000000,438.500000  "
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M410.000000,41.500000  C409.333344,47.500000 408.613770,53.494968 408.042297,59.504021  C407.920471,60.785141 407.328461,62.549702 409.500000,63.000000  "
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M496.500000,340.500000  C496.500000,344.333344 496.500000,348.166656 496.500000,352.000000  "
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M624.500000,278.000000  C629.646179,283.607819 629.382690,290.605743 629.484863,297.500214  C629.498230,298.401581 628.902954,298.902985 628.000000,299.000000  "
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1472.000000,417.000000  C1464.721924,416.057098 1461.717773,420.062775 1464.609009,427.271912  C1467.793823,425.077484 1470.337158,422.558563 1472.052490,419.025482  C1475.025879,412.901001 1476.543213,412.339661 1483.000000,413.999969  C1486.671997,414.944214 1491.571899,411.741272 1491.406250,408.004150  C1491.178223,402.854401 1496.145508,401.536255 1498.000000,398.000000  "
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M474.000000,57.000000  C469.997589,57.351822 465.442932,55.586758 462.500000,60.000000  "
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M456.000000,473.000000  C459.697388,474.896820 463.669006,473.639587 467.500000,474.000000  "
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M470.000000,417.500000  C472.962616,420.830841 470.874573,424.850433 471.500000,428.500000  "
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1708.000000,217.500000  C1708.831665,221.166672 1708.831665,224.833328 1708.000000,228.500000  "
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M471.000000,354.500000  C470.168396,358.166656 470.168396,361.833344 471.000000,365.500000  "
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1312.500000,360.500000  C1308.840332,360.180634 1305.121704,361.156006 1301.500000,360.000000  "
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M764.500000,360.500000  C764.500000,364.166656 764.500000,367.833344 764.500000,371.500000  "
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M53.500000,238.000000  C49.891991,238.978577 46.001392,236.848633 42.500000,239.000000  "
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M780.000000,342.500000  C779.168396,346.166656 779.168396,349.833344 780.000000,353.500000  "
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M782.000000,342.500000  C782.831604,346.166656 782.831604,349.833344 782.000000,353.500000  "
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M904.000000,342.500000  C903.168396,346.166656 903.168396,349.833344 904.000000,353.500000  "
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1312.500000,344.000000  C1308.833374,344.642609 1305.166626,342.875031 1301.500000,344.000000  "
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M906.000000,342.500000  C906.831604,346.166656 906.831604,349.833344 906.000000,353.500000  "
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1311.500000,363.500000  C1307.863647,364.334625 1304.066040,361.619995 1300.500000,364.000000  "
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1028.000000,342.500000  C1027.168335,346.166656 1027.168335,349.833344 1028.000000,353.500000  "
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1030.000000,342.500000  C1030.831665,346.166656 1030.831665,349.833344 1030.000000,353.500000  "
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1312.500000,376.500000  C1308.840332,376.180634 1305.121704,377.156006 1301.500000,376.000000  "
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M409.500000,524.500000  C407.067902,526.804382 407.300629,530.178345 408.197693,532.420898  C410.194336,537.412537 408.717865,542.582031 410.000000,547.500000  "
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1705.000000,410.500000  C1704.245361,414.500000 1704.067871,418.500000 1705.000000,422.500000  "
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1568.000000,195.500000  C1568.877563,196.311203 1569.477051,197.226425 1569.513306,198.499619  C1569.646240,203.167252 1569.833374,207.833328 1570.000000,212.500000  "
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1629.000000,195.500000  C1628.122437,196.311203 1627.522827,197.226425 1627.486572,198.499619  C1627.353516,203.167252 1627.166626,207.833328 1627.000000,212.500000  "
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M309.000000,112.000000  C312.627472,113.028702 316.336914,112.254662 320.000000,112.500000  "
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M489.000000,340.000000  C490.790649,339.698700 490.505676,340.942230 490.502930,342.000000  C490.494720,345.166656 490.500000,348.333344 490.500000,351.500000  "
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M470.500000,97.000000  C466.324768,102.641640 466.324768,102.802086 470.500000,108.000000  "
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M320.000000,476.500000  C316.336914,476.745331 312.627472,475.971283 309.000000,477.000000  "
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M470.000000,500.000000  C467.700714,503.189026 470.375031,507.325409 468.000000,510.500000  "
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M451.500000,509.500000  C451.500000,506.166656 451.500000,502.833344 451.500000,499.500000  C450.333344,499.500000 449.166656,499.500000 447.883606,499.500000  C446.741333,501.701141 448.302277,504.305084 447.000000,506.500000  "
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1231.500000,404.500000  C1225.170166,404.798828 1218.808472,403.888947 1212.500000,405.000000  "
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    d: " M51.000000,237.000000  C47.697708,234.513962 46.024422,229.396454 40.500000,230.500000  "
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M276.000000,227.500000  C274.780334,230.271393 274.712921,232.973282 275.406616,236.021255  C277.206573,243.929718 274.714325,251.999390 275.887299,260.016479  C276.253479,262.519440 274.503601,264.882507 273.000000,267.000000  "
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1705.000000,401.500000  C1708.500000,401.500000 1712.000000,401.500000 1715.500000,401.500000  "
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12,
    d: " M1631.500000,218.000000  C1631.500000,226.500000 1631.500000,235.000000 1631.500000,243.500000  "
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M320.000000,500.000000  C322.299286,503.189026 319.624969,507.325409 322.000000,510.500000  "
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1666.000000,206.500000  C1664.848022,209.580490 1664.450806,212.607330 1664.856812,216.017044  C1665.424438,220.782791 1665.000000,225.666672 1665.000000,230.500000  "
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1502.000000,205.500000  C1503.810791,206.773438 1503.496948,208.687363 1503.498169,210.500000  C1503.502808,217.166672 1503.500000,223.833328 1503.500000,230.500000  "
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1463.000000,401.500000  C1459.500000,401.500000 1456.000000,401.500000 1452.500000,401.500000  "
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M699.000000,527.000000  C695.500000,527.000000 692.000000,527.000000 688.500000,527.000000  "
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1029.000000,360.500000  C1029.000000,364.000000 1029.000000,367.500000 1029.000000,371.000000  "
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M905.000000,360.500000  C905.000000,364.000000 905.000000,367.500000 905.000000,371.000000  "
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M1675.000000,196.000000  C1673.833374,196.000000 1672.653564,196.112549 1671.502319,195.979446  C1667.664673,195.535721 1666.386841,197.225708 1666.408569,201.000534  C1666.430542,204.788116 1667.648438,206.263474 1671.509277,205.550400  C1673.874512,205.113617 1675.915771,206.168701 1677.500000,208.000000  "
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M528.000000,492.000000  C532.359558,492.020996 534.534790,494.562439 535.500000,498.500000  "
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M471.500000,476.500000  C475.000000,476.500000 478.500000,476.500000 482.000000,476.500000  "
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1678.500000,419.500000  C1683.706787,421.739960 1681.787842,425.761383 1681.000000,429.500000  "
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M781.000000,360.500000  C781.000000,364.000000 781.000000,367.500000 781.000000,371.000000  "
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1715.500000,238.500000  C1712.000000,238.500000 1708.500000,238.500000 1705.000000,238.500000  "
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M343.000000,506.500000  C341.853027,504.408752 342.878601,502.150360 342.400482,499.907684  C341.280457,498.923035 339.803406,499.906128 338.500000,499.350494  C338.500000,502.833344 338.500000,506.166656 338.500000,509.500000  "
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1463.000000,238.500000  C1459.500000,238.500000 1456.000000,238.500000 1452.500000,238.500000  "
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1569.000000,213.500000  C1573.369263,211.401062 1578.014038,213.023407 1582.500000,212.499863  C1584.494507,212.267075 1586.573486,213.049225 1588.500000,212.000000  "
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1090.500000,404.999969  C1087.166626,404.666656 1083.833374,404.333313 1080.500000,403.999969  "
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M771.500000,376.000000  C771.012146,379.366058 773.225220,382.597076 772.000000,386.000000  "
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M454.500000,511.000000  C454.500000,515.833313 454.500000,520.666687 454.500000,525.500000  "
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M52.500000,327.000000  C49.211914,328.071655 45.828709,327.240845 42.500000,327.500000  "
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1298.000000,315.500000  C1296.928345,318.788086 1297.759155,322.171295 1297.500000,325.500000  "
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M783.000000,323.500000  C782.666687,326.833344 782.333313,330.166656 782.000000,333.500000  "
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1091.500000,225.500000  C1086.450806,223.345642 1081.180176,224.621323 1076.000000,224.502090  C1074.032715,224.456802 1071.569580,224.930450 1073.000000,221.500000  "
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M335.500000,511.000000  C335.500000,515.833313 335.500000,520.666687 335.500000,525.500000  "
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1301.000000,315.500000  C1302.071655,318.788086 1301.240845,322.171295 1301.500000,325.500000  "
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    d: " M556.500000,229.000000  C556.584534,231.041061 555.927856,233.166245 558.951721,234.148575  C560.398804,234.618652 561.333313,236.666687 562.500000,238.000015  "
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M496.500000,232.500000  C484.867554,234.031357 473.172913,233.399231 461.499847,233.477463  C459.961060,233.487793 458.385315,233.881882 456.971313,232.530014  C452.597137,228.347961 446.885925,228.630798 441.499207,228.568924  C425.001373,228.379395 408.500000,228.500000 391.456451,228.500000  C392.018127,240.666672 391.359253,252.816025 391.809448,265.007050  C392.047394,271.450012 391.340485,278.008759 391.560822,284.497925  C391.996643,297.332092 391.777924,310.180420 391.767975,322.999817  C391.754578,340.326385 391.713135,357.667084 391.512421,375.000153  C391.472443,378.456573 391.924835,381.848358 393.500000,385.000000  "
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M495.500000,359.500000  C497.671906,362.824890 495.914062,366.524048 496.500000,370.000000  "
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M313.000000,394.000031  C311.500000,393.833344 309.994293,393.492859 308.501373,393.541809  C306.392212,393.610931 304.821747,394.383759 305.750000,397.000000  "
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1570.000000,425.000000  C1569.833374,430.000000 1569.612061,434.999146 1569.534058,440.000519  C1569.511108,441.462921 1569.036255,442.563141 1568.000000,443.500000  "
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M52.500000,340.000000  C47.000000,340.000000 41.500000,340.000000 36.000000,340.000000  "
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M331.500000,78.000000  C333.580719,81.681389 332.020874,85.679344 332.500000,89.500000  "
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M457.500000,79.500000  C457.500000,82.833336 457.500000,86.166664 457.500000,89.500000  "
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M52.500000,279.500000  C47.166668,279.500000 41.833332,279.500000 36.500000,279.500000  "
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1676.500000,450.500000  C1673.166626,450.500000 1669.833374,450.500000 1666.500000,450.500000  "
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    d: " M563.500000,229.000000  C563.584534,231.041061 562.927856,233.166275 565.951721,234.148575  C567.398865,234.618683 568.333313,236.666656 569.500000,238.000000  "
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M305.750000,192.000000  C304.821869,194.616150 306.392242,195.389099 308.501373,195.458221  C309.994293,195.507172 311.500000,195.166656 313.000000,195.000000  "
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    d: " M570.500000,229.000000  C570.584534,231.041061 569.927856,233.166245 572.951721,234.148575  C574.398804,234.618652 575.333313,236.666687 576.500000,238.000015  "
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M265.500000,378.000000  C265.147095,381.739197 267.463104,384.677734 268.500000,388.000000  "
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    d: " M588.500000,229.000000  C588.584534,231.041061 587.927856,233.166245 590.951721,234.148575  C592.398804,234.618652 593.333313,236.666672 594.500000,238.000015  "
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    d: " M595.500000,229.000000  C595.584534,231.041061 594.927856,233.166275 597.951721,234.148575  C599.398865,234.618683 600.333313,236.666656 601.500000,238.000000  "
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M418.500000,524.500000  C421.223328,527.315613 419.553772,530.824829 420.000000,534.000000  "
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1332.000000,239.000000  C1335.328857,239.256577 1338.711792,238.432022 1342.000000,239.500000  "
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M52.500000,352.000000  C49.211914,353.071655 45.828709,352.240845 42.500000,352.500000  "
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1301.000000,347.500000  C1301.792480,350.833344 1301.792480,354.166656 1301.000000,357.500000  "
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M52.500000,370.000000  C49.211914,371.071655 45.828709,370.240845 42.500000,370.500000  "
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M52.500000,264.000000  C49.211914,265.071655 45.828709,264.240845 42.500000,264.500000  "
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1081.500000,380.000000  C1081.012207,383.366058 1083.225220,386.597076 1082.000000,390.000000  "
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1090.000000,347.500000  C1089.207520,350.833344 1089.207520,354.166656 1090.000000,357.500000  "
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1298.000000,347.500000  C1297.207520,350.833344 1297.207520,354.166656 1298.000000,357.500000  "
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1093.000000,347.500000  C1093.792480,350.833344 1093.792480,354.166656 1093.000000,357.500000  "
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1197.000000,347.500000  C1197.792480,350.833344 1197.792480,354.166656 1197.000000,357.500000  "
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1342.000000,400.000000  C1338.711792,401.067963 1335.328857,400.243439 1332.000000,400.500000  "
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1194.000000,347.500000  C1193.207520,350.833344 1193.207520,354.166656 1194.000000,357.500000  "
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    d: " M1705.500000,214.000000  C1703.711548,211.570755 1702.332520,213.047516 1701.005127,214.504700  C1697.405640,218.456711 1695.369507,223.576492 1691.063965,227.078674  C1687.711182,229.806168 1684.463257,230.765442 1680.256958,229.210876  C1676.505249,232.344421 1674.718384,237.436768 1671.000000,241.000000  "
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1680.500000,410.000000  C1689.280151,408.343872 1697.052002,414.339325 1698.000000,423.500000  "
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M346.500000,514.000000  C343.324768,515.914429 339.827545,514.608887 336.500000,515.000000  "
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M453.500000,515.000000  C450.172455,514.608887 446.675232,515.914429 443.500000,514.000000  "
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M457.500000,500.000000  C457.500000,503.166656 457.500000,506.333344 457.500000,509.500000  "
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M332.500000,500.000000  C332.500000,503.166656 332.500000,506.333344 332.500000,509.500000  "
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M329.500000,60.500000  C328.333344,64.833336 327.166656,69.166664 326.000000,73.500000  "
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M496.500000,376.000000  C496.202332,376.992004 494.321045,375.872528 494.553162,378.018921  C498.298706,379.299591 502.798004,377.736328 506.500000,380.000000  "
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1488.500000,429.500000  C1488.000000,429.500000 1487.316650,429.284821 1487.026978,429.531616  C1480.632935,434.979248 1473.100342,432.319214 1465.998901,432.424713  C1463.719238,432.458618 1461.605835,432.770935 1459.500000,433.500000  "
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M320.000000,93.500000  C322.224945,98.544624 322.954102,103.604599 321.116333,109.039337  C320.524414,110.789795 320.478333,113.071251 321.500000,115.000000  "
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1705.000000,217.500000  C1704.117188,221.166672 1704.282593,224.833328 1705.000000,228.500000  "
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1464.000000,213.500000  C1463.572144,222.860519 1462.062622,232.261856 1465.026245,241.491547  C1465.154541,241.890762 1465.666626,242.166702 1466.000000,242.500031  "
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M496.500000,270.000000  C496.202332,270.992004 494.321045,269.872528 494.553162,272.018921  C498.298706,273.299591 502.798004,271.736328 506.500000,274.000000  "
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M610.500000,413.000000  C618.479797,411.862244 626.503235,412.849396 634.502197,412.559906  C635.319336,412.530334 636.166687,413.333344 637.000000,413.750000  "
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M608.500000,360.500000  C608.500000,363.666656 608.500000,366.833344 608.500000,370.000000  "
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M484.000000,192.000000  C484.361481,194.333649 483.754883,195.838623 481.000061,195.499557  C479.666412,195.335419 478.333344,195.166672 477.000000,195.000000  "
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    d: " M485.000000,399.500000  C480.763275,402.624634 481.261353,408.606964 477.481842,411.979645  C476.223114,413.102844 476.731689,414.515411 477.078949,415.471313  C479.197144,421.301819 478.673370,427.108795 477.559448,433.011230  C477.257355,434.611664 477.198730,436.396790 478.000000,438.000000  "
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    d: " M585.500000,229.000000  C584.290100,233.598083 589.065186,234.871201 590.500000,238.000000  "
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M323.000000,417.500000  C324.106964,419.766174 323.520752,422.190521 323.403717,424.495117  C323.309937,426.342041 324.580139,426.369232 325.500000,427.000000  "
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M467.000000,417.500000  C465.893036,419.766174 466.479309,422.190521 466.596313,424.495117  C466.690125,426.342041 465.419861,426.369232 464.500000,427.000000  "
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1089.500000,344.000000  C1086.371094,343.173370 1083.303955,342.902039 1080.500000,345.000000  "
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M165.000000,331.500000  C165.000000,338.000000 165.000000,344.500000 165.000000,351.000000  "
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M472.000000,429.500000  C473.472992,432.373383 471.527008,435.626617 473.000000,438.500000  "
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    d: " M592.500000,229.000000  C591.290100,233.598083 596.065186,234.871201 597.500000,238.000000  "
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    d: " M581.500000,229.000000  C580.290100,233.598083 585.065186,234.871201 586.500000,238.000000  "
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    d: " M578.500000,229.000000  C577.290100,233.598083 582.065186,234.871201 583.500000,238.000000  "
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    d: " M574.500000,229.000000  C573.290100,233.598083 578.065186,234.871201 579.500000,238.000000  "
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    d: " M567.500000,229.000000  C566.290100,233.598083 571.065186,234.871201 572.500000,238.000000  "
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    d: " M560.500000,229.000000  C559.290100,233.598083 564.065186,234.871201 565.500000,238.000000  "
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    d: " M553.500000,229.000000  C552.290100,233.598083 557.065186,234.871201 558.500000,238.000000  "
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    d: " M549.500000,229.000000  C548.290100,233.598083 553.065186,234.871201 554.500000,238.000000  "
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    d: " M546.500000,229.000000  C545.290100,233.598083 550.065186,234.871201 551.500000,238.000000  "
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    d: " M266.500000,256.000000  C268.705200,259.037567 271.126953,261.759277 275.250000,262.000000  "
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M789.500000,305.500000  C783.615112,303.094849 777.496155,304.623566 771.500854,304.657074  C769.740356,304.666870 767.826660,304.759888 766.000000,305.000000  "
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M483.000000,171.000000  C485.865417,173.535446 484.343628,176.587021 484.000000,179.500000  "
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M321.500000,474.500000  C320.275635,476.237183 320.607422,478.390411 321.119415,479.961060  C322.887329,485.384430 322.143005,490.450073 320.000000,495.500000  "
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M592.000000,398.500000  C591.885132,401.502869 592.354797,404.538239 591.500000,407.500000  "
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M540.000000,398.500000  C539.885132,401.502869 540.354797,404.538239 539.500000,407.500000  "
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M490.500000,399.000000  C491.175690,401.831207 488.819061,405.375916 492.500000,407.500000  "
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1078.000000,312.500000  C1082.189087,312.106506 1086.403198,311.086609 1090.500000,313.000000  "
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    d: " M267.000000,343.000000  C269.931030,345.038910 271.196838,349.255402 275.500000,349.500000  "
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1074.500000,360.000000  C1074.027222,360.860596 1071.611450,360.259705 1072.580933,361.953674  C1073.680176,363.874451 1075.488647,364.890167 1078.012207,364.036133  C1082.133667,362.641388 1086.333374,362.194153 1090.500000,364.000000  "
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M492.000000,327.500000  C496.493866,327.167725 501.036926,328.163605 505.500000,327.000000  "
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M491.500000,370.000000  C496.166656,370.815857 500.833344,370.816833 505.500000,370.000000  "
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M491.500000,352.000000  C496.166656,352.815857 500.833344,352.816833 505.500000,352.000000  "
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    d: " M267.000000,375.000000  C269.931030,377.038910 271.196838,381.255402 275.500000,381.500000  "
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M491.500000,301.500000  C496.112183,299.807678 500.803894,300.342743 505.500000,301.000000  "
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M624.000000,336.000000  C626.802612,340.441620 630.452026,344.591278 629.000000,350.500000  "
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1090.500000,340.000000  C1086.821289,342.111816 1082.815796,340.465027 1079.000000,341.000000  "
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1077.500000,380.000000  C1081.833374,378.640106 1086.166626,378.320068 1090.500000,380.000000  "
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M492.000000,264.500000  C496.493866,264.167725 501.036926,265.163605 505.500000,264.000000  "
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1682.000000,201.500000  C1680.907471,200.465591 1681.804199,199.147018 1681.414917,197.820648  C1679.851440,197.559586 1678.175659,197.279800 1676.500000,197.000000  "
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M410.000000,53.500000  C412.826233,53.212528 415.722412,54.114300 418.500000,53.000000  "
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M475.000000,48.500000  C475.000000,52.500000 475.000000,56.500000 475.000000,60.500000  "
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1078.000000,272.500000  C1082.189087,272.106506 1086.403198,271.086609 1090.500000,273.000000  "
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1487.000000,420.500000  C1485.757446,423.270050 1485.689087,426.109161 1486.500000,429.000000  "
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M335.500000,66.000000  C335.787476,68.826225 334.885712,71.722412 336.000000,74.500000  "
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M474.000000,463.500000  C472.885712,466.277588 473.787476,469.173767 473.500000,472.000000  "
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M459.500000,94.500000  C456.075867,96.691956 456.244385,100.860565 456.899475,103.396820  C457.465576,105.588585 455.548767,109.431488 459.500000,110.500000  "
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M454.500000,66.000000  C454.212524,68.826225 455.114288,71.722412 454.000000,74.500000  "
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M410.000000,535.500000  C412.833344,535.500000 415.666656,535.500000 418.500000,535.500000  "
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M779.500000,336.000000  C776.833313,336.785431 774.166687,336.785431 771.500000,336.000000  "
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M782.000000,435.000000  C781.372070,437.314545 780.539856,439.660522 783.322815,441.740753  C785.080383,438.106598 789.771973,443.420135 791.467590,438.987610  C792.023193,437.535370 791.160645,436.383545 790.000000,435.500000  "
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    d: " M392.500000,395.000000  C394.949615,397.254791 395.793610,400.901093 399.000000,402.500000  "
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1705.500000,206.000000  C1706.153687,206.205063 1706.807373,206.410110 1707.500000,206.627396  C1707.815674,209.364716 1704.055176,209.851608 1704.000000,212.500000  "
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M460.500000,74.750000  C464.696198,72.907120 469.136047,73.598282 473.500000,73.500000  "
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1089.500000,360.000000  C1086.833374,360.785431 1084.166626,360.785431 1081.500000,360.000000  "
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M490.500000,331.500000  C490.500000,334.166656 490.500000,336.833344 490.500000,339.991547  C493.629181,339.774994 496.909088,340.954590 499.500000,338.000000  "
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M266.000000,245.500000  C265.523560,251.910416 264.517273,258.362671 267.500000,264.500000  "
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M767.500000,386.000000  C771.833313,387.023560 776.166687,387.804474 780.500000,386.000000  "
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1323.500000,344.500000  C1325.021729,344.615845 1325.847778,343.688385 1326.663818,342.825958  C1325.831055,340.228394 1323.929321,341.243988 1322.500000,341.000000  "
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M320.500000,116.500000  C322.313721,121.445099 319.144562,126.556290 321.000000,131.500000  "
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M642.500000,404.000000  C637.833313,406.060669 633.166687,405.683990 628.500000,404.000000  "
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M645.500000,413.000000  C643.000000,412.083130 640.500000,412.334778 638.000000,413.000000  "
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M609.000000,344.500000  C607.966980,346.942230 608.738647,349.504791 608.500000,352.000000  "
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M443.000000,472.500000  C446.500000,470.395203 450.000000,472.198151 453.500000,472.500000  "
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M764.500000,444.500000  C767.000000,444.500000 769.500000,444.500000 772.000000,444.500000  "
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M57.500000,229.000000  C66.317596,227.999084 75.167519,228.735977 84.000847,228.537872  C91.996826,228.358551 100.000000,228.500000 108.000000,228.500000  C117.666664,228.500000 127.336090,228.375717 136.998016,228.589691  C139.337326,228.641495 142.616455,227.719910 143.500000,231.500000  "
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1077.500000,375.000000  C1081.392090,376.627625 1085.388184,377.007965 1089.500000,376.000000  "
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M439.500000,115.000000  C443.889343,116.495956 448.416779,116.749039 453.000000,116.500000  "
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1500.500000,235.500000  C1500.069580,237.848251 1501.654297,240.628296 1499.000000,242.500000  "
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1077.500000,390.000000  C1081.432251,391.146606 1085.374756,392.168884 1089.500000,391.000000  "
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M432.500000,118.000000  C432.309052,122.332397 433.102081,126.702644 432.000000,131.000000  "
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M497.500000,374.000000  C494.993561,371.269775 492.105835,374.640076 489.500000,373.500000  "
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M468.000000,76.500000  C470.190887,78.276466 469.491547,80.759247 469.457428,82.999352  C469.419281,85.505890 469.538361,87.839279 471.750000,89.500000  "
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M399.500000,273.000000  C401.945892,273.149963 401.355377,275.602631 401.345459,276.498291  C401.267975,283.496857 401.992462,290.519653 401.000000,297.500000  "
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1670.000000,396.500000  C1667.345825,398.265472 1668.078125,400.998505 1668.000000,403.500000  "
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M319.000000,415.000000  C316.816833,413.799164 314.598511,412.762512 312.000000,413.500000  "
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M321.000000,457.500000  C320.184875,459.833344 320.184875,462.166656 321.000000,464.500000  "
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M534.500000,484.000000  C534.132629,486.821533 535.268188,489.731476 534.000000,492.500000  "
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M627.500000,255.000000  C629.956604,256.715149 629.861389,259.019165 629.000000,261.500000  "
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M497.500000,268.000000  C494.993561,265.269775 492.105835,268.640076 489.500000,267.500000  "
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M627.500000,248.000000  C629.956604,249.715134 629.861389,252.019165 629.000000,254.500000  "
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M399.500000,248.000000  C401.945892,248.149979 401.355377,250.602631 401.345459,251.498291  C401.267975,258.496857 401.992462,265.519653 401.000000,272.500000  "
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M399.500000,298.000000  C401.945892,298.149963 401.360809,300.604767 401.349030,301.498016  C401.225861,310.830994 402.002655,320.181610 401.000000,329.500000  "
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M268.500000,265.500000  C276.504333,268.406494 278.356201,273.625427 274.000000,281.000000  "
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M399.500000,355.000000  C401.762543,356.253021 401.496185,358.430939 401.497498,360.500000  C401.503326,369.666656 401.500000,378.833344 401.500000,388.000000  "
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M481.000000,472.000000  C477.954224,473.481659 474.564667,471.697693 471.500000,473.000000  "
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M319.000000,174.000000  C316.774567,175.088593 314.589844,176.462296 312.000000,175.000000  "
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M522.500000,231.500000  C520.097473,230.697830 517.740967,230.540283 515.500000,232.000000  "
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1098.500000,406.000000  C1096.305298,403.892059 1093.833252,405.667114 1091.500000,405.500000  "
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10,
    d: " M478.000000,152.500000  C476.588745,156.238388 479.303436,159.736923 478.571960,163.513931  C478.026001,166.332886 478.781921,169.216782 477.178101,172.099106  C476.252533,173.762527 476.295288,176.684570 478.054047,178.446045  C479.392151,179.786240 479.686554,181.488953 480.500000,183.000000  "
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M399.500000,330.000000  C401.945892,330.149963 401.355377,332.602631 401.345459,333.498291  C401.267975,340.496857 401.992462,347.519653 401.000000,354.500000  "
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M484.500000,40.499996  C484.962402,41.192268 485.424805,41.884541 486.031525,42.792908  C481.500000,44.684669 477.000000,42.901928 472.500000,42.500000  "
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    d: " M1705.000000,426.000000  C1703.211914,427.333344 1703.912598,428.742249 1705.021118,429.981079  C1706.433716,431.559326 1708.000000,432.999969 1709.500000,434.499969  "
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1491.500000,223.500000  C1491.250854,225.991745 1491.001587,228.483505 1490.700073,231.500000  C1494.818848,231.500000 1498.659424,231.500000 1502.500000,231.500000  "
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M497.500000,356.000000  C495.333344,354.305481 493.256012,355.027863 490.967316,355.915741  C489.537109,356.470612 488.134583,355.312622 487.552887,353.976959  C486.758820,352.153687 489.027283,352.860596 489.500000,352.000000  "
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M387.500000,395.500000  C386.000000,395.500000 384.500000,395.500000 382.965424,395.500000  C383.496582,393.103363 384.488129,390.592468 381.500000,389.000000  "
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M542.000000,490.500000  C539.845398,490.823242 537.591736,489.859406 535.500000,491.000000  "
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1074.000000,341.000000  C1071.680298,342.731140 1071.705322,342.797638 1075.500000,345.000000  "
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1325.500000,363.000000  C1326.679810,360.500000 1326.679810,360.500000 1322.500000,360.500000  "
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M432.000000,460.000000  C433.714203,463.713257 431.586334,467.760620 433.000000,471.500000  "
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M438.000000,465.500000  C439.631317,467.647919 437.365112,470.352600 439.000000,472.500000  "
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1502.500000,450.500000  C1499.166626,450.500000 1495.833374,450.500000 1492.500000,450.500000  "
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M497.500000,387.000000  C495.621124,388.060150 493.643188,388.525726 491.500000,388.000000  "
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1325.500000,379.000000  C1326.679810,376.500000 1326.679810,376.500000 1322.500000,376.500000  "
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1488.500000,392.000000  C1488.500000,395.166656 1488.500000,398.333344 1488.500000,401.500000  "
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M754.500000,392.000000  C755.300537,390.927338 757.317383,391.327179 757.503540,389.500366  C757.670166,387.865295 755.795532,388.994843 755.500000,388.000000  "
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1664.500000,426.500000  C1665.825195,428.293701 1664.020020,430.869995 1666.000000,432.500000  "
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1502.500000,444.000000  C1504.145142,445.698944 1503.742798,447.583984 1503.000000,449.500000  "
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1492.000000,444.000000  C1491.399780,445.833344 1491.069824,447.666656 1492.000000,449.500000  "
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1676.500000,444.000000  C1678.145142,445.698944 1677.742798,447.583984 1677.000000,449.500000  "
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M369.500000,179.500000  C366.619019,175.984268 362.927795,177.870163 359.500000,178.000000  "
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1502.000000,414.500000  C1504.873901,420.358856 1503.313843,426.464050 1503.000000,432.500000  "
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1502.500000,189.500000  C1499.379395,188.457077 1496.161865,189.259018 1493.000000,189.000000  "
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M472.000000,109.000000  C475.053467,110.204300 478.060242,111.630516 481.500000,111.000000  "
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M483.500000,434.000000  C481.666656,434.000000 479.833344,434.000000 478.000000,434.000000  "
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M496.500000,379.500000  C496.893494,381.657410 495.602783,384.073944 497.500000,386.000000  "
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M330.000000,123.500000  C330.333344,125.333336 330.666656,127.166664 331.000000,129.000000  "
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1504.000000,233.000000  C1504.019531,234.897491 1504.784546,236.930527 1503.000000,238.500000  "
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M444.500000,503.500000  C444.582977,506.824493 446.592804,510.569641 442.483093,512.971069  C442.110352,513.188843 441.500000,513.000000 441.000000,513.000000  "
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M608.000000,504.000000  C610.491394,505.707123 607.869019,508.594330 609.500000,510.500000  "
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M349.000000,513.000000  C346.012482,513.340149 345.930847,510.411133 344.370148,508.872162  C339.335327,511.844238 332.935638,507.896027 328.000000,512.000000  "
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M471.500000,372.000000  C473.681274,374.093689 476.415863,373.420685 479.000000,373.500000  "
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M446.000000,509.000000  C449.031586,510.616577 452.313751,509.823578 455.498444,510.024841  C457.726379,510.165649 460.270172,509.107025 462.000000,511.500000  "
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M309.000000,473.000000  C312.666656,472.505981 316.333344,472.160980 320.000000,473.000000  "
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M430.500000,178.000000  C427.072205,177.870163 423.380981,175.984268 420.500000,179.500000  "
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1035.500000,266.000000  C1033.833374,265.666656 1032.166626,265.333344 1030.500000,265.000000  "
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1666.000000,444.500000  C1665.206421,446.166656 1665.206421,447.833344 1666.000000,449.500000  "
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1035.500000,307.000000  C1033.833374,307.333313 1032.166626,307.666656 1030.500000,308.000000  "
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1465.000000,427.500000  C1463.736206,429.098694 1461.534058,430.040558 1461.500000,432.500000  "
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M497.500000,331.000000  C495.900360,330.331604 494.452271,328.905243 492.500000,330.000000  "
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M474.000000,346.500000  C475.666656,346.500000 477.333344,346.500000 479.000000,346.500000  "
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M312.000000,346.500000  C313.666656,346.500000 315.333344,346.500000 317.000000,346.500000  "
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1705.000000,232.500000  C1703.345093,235.635696 1705.902344,239.613785 1703.000000,242.500000  "
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M714.000000,400.000000  C714.418091,401.500000 715.105347,403.000000 714.000000,404.500000  "
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M329.000000,426.000000  C330.500000,426.418091 332.000000,427.105347 333.500000,426.000000  "
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1492.000000,190.500000  C1491.344849,192.091309 1490.925659,193.656418 1492.500000,195.000000  "
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1503.000000,190.500000  C1503.655151,192.091309 1504.074341,193.656418 1502.500000,195.000000  "
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1677.000000,190.500000  C1677.655151,192.091309 1678.074341,193.656418 1676.500000,195.000000  "
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    d: " M1699.000000,424.000000  C1700.310791,425.410004 1701.698730,426.720612 1703.500000,427.500000  "
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    d: " M1671.000000,395.000000  C1675.889648,394.931976 1675.631592,399.365967 1676.269775,402.054626  C1676.934814,404.856293 1676.778320,407.586334 1679.455322,409.560638  C1680.812500,410.561493 1679.817505,411.926300 1679.000000,413.000000  "
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M461.000000,426.000000  C459.500000,426.418091 458.000000,427.105347 456.500000,426.000000  "
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1101.000000,396.000000  C1100.903931,400.019775 1101.517334,404.098663 1100.000000,408.000000  "
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M763.500000,372.000000  C762.360107,372.731140 759.918579,373.028412 762.500000,375.000000  "
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1034.500000,373.000000  C1033.422607,371.642700 1031.577393,373.357300 1030.500000,372.000000  "
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M489.500000,370.000000  C488.360107,370.731140 485.918610,371.028412 488.500000,373.000000  "
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M465.500000,531.500000  C464.179352,531.231812 462.721924,532.057983 461.500000,531.000000  "
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    d: " M266.500000,288.000000  C267.666656,289.333344 268.833344,290.666656 270.000000,292.000000  "
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1504.000000,402.500000  C1505.473022,403.833344 1503.811768,405.166656 1504.000000,406.500000  "
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1665.000000,402.500000  C1663.526978,403.833344 1665.188232,405.166656 1665.000000,406.500000  "
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1074.500000,391.000000  C1073.360107,391.731140 1070.918579,392.028412 1073.500000,394.000000  "
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M36.500000,223.000000  C35.360115,223.731155 32.918602,224.028427 35.500000,226.000000  "
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M479.500000,464.000000  C478.422668,462.642700 476.577332,464.357300 475.500000,463.000000  "
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M763.500000,387.000000  C762.360107,387.731140 759.918579,388.028412 762.500000,390.000000  "
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M489.500000,223.000000  C488.360107,223.731155 485.918610,224.028427 488.500000,226.000000  "
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M763.500000,356.000000  C762.360107,356.731140 759.918579,357.028412 762.500000,359.000000  "
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1034.500000,357.000000  C1033.422607,355.642700 1031.577393,357.357300 1030.500000,356.000000  "
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M313.500000,387.000000  C316.928802,385.919098 320.334686,384.921143 324.020325,385.925354  C324.711517,386.113647 325.666656,385.333313 326.500000,385.000000  "
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M305.000000,398.000000  C304.394623,399.429840 303.972321,400.836792 305.500000,402.000000  "
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M333.500000,412.000000  C332.166656,411.179474 330.833344,411.179474 329.500000,412.000000  "
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M460.500000,412.000000  C459.166656,411.179474 457.833344,411.179474 456.500000,412.000000  "
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1074.500000,376.000000  C1073.360107,376.731140 1070.918579,377.028412 1073.500000,379.000000  "
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1676.000000,406.500000  C1672.840210,408.568970 1669.327881,407.111938 1666.000000,407.500000  "
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1034.500000,337.000000  C1033.422607,335.642700 1031.577393,337.357300 1030.500000,336.000000  "
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1666.000000,190.500000  C1665.179443,191.833328 1665.179443,193.166672 1666.000000,194.500000  "
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M305.500000,187.000000  C303.972321,188.163208 304.394623,189.570160 305.000000,191.000000  "
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1704.000000,395.500000  C1702.507080,399.332672 1704.572632,402.841888 1705.000000,406.500000  "
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1677.500000,235.000000  C1679.654175,236.292404 1679.565186,238.351303 1679.538330,240.500473  C1679.513306,242.499298 1679.099121,244.561188 1680.000000,246.500000  "
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1490.500000,235.000000  C1488.345825,236.292404 1488.434814,238.351303 1488.461670,240.500473  C1488.486694,242.499298 1488.900879,244.561188 1488.000000,246.500000  "
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1077.000000,309.000000  C1076.000000,309.166687 1075.003906,309.363068 1073.999268,309.494293  C1071.327759,309.843140 1072.376953,310.908722 1073.500000,312.000000  "
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M763.000000,305.000000  C760.935364,305.683685 761.025635,306.726501 762.500000,308.000000  "
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M769.000000,264.999969  C766.492615,265.276550 763.985168,265.553101 761.583313,265.818024  C761.223083,266.971802 761.921631,267.455872 762.500000,268.000000  "
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M484.500000,187.000000  C485.696808,188.019501 485.938782,189.175415 485.000000,190.500000  "
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M482.500000,125.000000  C480.317505,126.389168 477.683228,124.616013 475.500000,126.000000  "
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1676.000000,233.000000  C1672.953247,230.589249 1669.368774,231.764053 1666.000000,231.500000  "
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M769.000000,372.000000  C767.833313,372.408569 766.666687,373.039246 765.500000,372.000000  "
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M769.000000,356.000000  C767.833313,356.408569 766.666687,357.039246 765.500000,356.000000  "
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M665.500000,485.500000  C667.500000,485.500000 669.500000,485.500000 671.500000,485.500000  "
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M546.500000,485.500000  C548.500000,486.694550 550.500000,485.391357 552.500000,485.500000  "
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M459.500000,78.000000  C457.833344,79.140793 456.166656,78.645058 454.500000,78.000000  "
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M463.500000,385.000000  C465.447144,386.760193 467.823090,385.732788 469.999908,386.000702  C472.176544,386.268616 474.554901,385.226562 476.500000,387.000000  "
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    d: " M364.500000,402.500000  C363.562408,403.091614 363.347931,403.972504 363.500000,405.000000  "
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M1460.500000,434.000000  C1460.709229,435.667145 1460.351196,437.010162 1458.500000,437.500000  "
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M382.000000,396.500000  C380.920532,399.239807 378.536255,398.443512 376.499725,398.486298  C373.834229,398.542297 371.166656,398.500000 368.500000,398.500000  "
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    d: " M1489.000000,418.500000  C1488.666626,419.000000 1488.333374,419.500000 1488.000000,420.000000  "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoline);
export default __webpack_public_path__ + "static/media/autoline.e2b6f21667050886764aedf486675d44.svg";
export { ForwardRef as ReactComponent };